import axios from "axios";
import {IRespuesta} from "services-comun/modules/net/interface";
import moment from "moment-timezone"
import intlTelInput from 'intl-tel-input';

interface IPInfo{
    "ip": any,
    "network": any,
    "version": any,
    "city": any,
    "region": any,
    "region_code": any,
    "country": any,
    "country_name": any,
    "country_code": any,
    "country_code_iso3": any,
    "country_capital": any,
    "country_tld": any,
    "continent_code": any,
    "in_eu": any,
    "postal": any,
    "latitude": any,
    "longitude": any,
    "timezone": any,
    "utc_offset": any,
    "country_calling_code": any,
    "currency": any,
    "currency_name": any,
    "languages": any,
    "country_area": any,
    "country_population": any,
    "asn": any,
    "org": any
}

interface IFtrialTotal{
    contact: IContactForm,
    solarAssets: IFTrialSolar[],
    windAssets: IFTrialWind[]
}

interface IContactForm {
    name:string,
    surename: string,
    company: string
    position:string,
    country:string,
    phone: string,
    email: string,
    accept: boolean,
}

interface IFTrialSolar {
    nameStation: string,
    location: string,
    latitude: string,
    longitude: string,
    ac: string,
    dc: string,
    trackingType: string,

    //OJO cuidado ponemos string pero en realidad es DATE
    COD:string,
    power:boolean,
    temperature: boolean,
    GHI: boolean,
    DNI: boolean,
    DHI: boolean,
    cloud: boolean,
    delivery: IFTrialDelivery[],
}

interface IFTrialDelivery {
    delivery_each: string,
    start_hour: string,
    timeStamp: string,
    resolution: string,
    csv: boolean,
    xls: boolean,
    ftp: boolean,
    api: boolean,
    email: boolean,
}

interface IFTrialWind {
    nameStation: string,
    location: string,
    latitude: string,
    longitude: string,
    nominal: string,
    power: boolean,
    wind: boolean,
    direction: boolean,
    pression: boolean
    delivery: IFTrialDelivery[],
}

interface IMail {
    contact: any,
    windAssets: any,
    solarAssets: any
}



const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export class freeTrial {
    //Clonar un nodo
    protected input0;
    protected svg0 ;
    protected svg1;
    protected labelCheck;

    /* STATIC */
    public static async init(): Promise<void> {
        new this();
    }

    /* INSTANCE */
    //Botonera
    protected readonly bb1: HTMLElement;
    protected readonly bb2: HTMLElement;
    protected readonly bb3: HTMLElement;
    protected readonly bb4: HTMLElement;

    protected readonly bb1_solar: HTMLElement;
    protected readonly bb2_solar: HTMLElement;
    protected readonly bb3_solar: HTMLElement;
    protected readonly bb4_solar: HTMLElement;
    protected readonly bb1_wind: HTMLElement;
    protected readonly bb2_wind: HTMLElement;
    protected readonly bb3_wind: HTMLElement;
    protected readonly bb4_wind: HTMLElement;

    //Botones
    protected readonly b1: HTMLLIElement;
    protected readonly b2: HTMLLIElement;
    protected readonly b3: HTMLLIElement;
    protected readonly b4: HTMLLIElement;
    protected readonly b1_solar: HTMLLIElement;
    protected readonly b2_solar: HTMLLIElement;
    protected readonly b3_solar: HTMLLIElement;
    protected readonly b4_solar: HTMLLIElement;
    protected readonly b1_wind: HTMLLIElement;
    protected readonly b2_wind: HTMLLIElement;
    protected readonly b3_wind: HTMLLIElement;
    protected readonly b4_wind: HTMLLIElement;

    //Formulario IContactForm
    protected readonly name: HTMLInputElement;
    protected readonly name_error_msg: HTMLElement;
    protected readonly surename: HTMLInputElement;
    protected readonly surename_error_msg: HTMLElement;
    protected readonly company: HTMLInputElement;
    protected readonly company_error_msg: HTMLElement;
    protected readonly position: HTMLInputElement;
    protected readonly email: HTMLInputElement;
    protected readonly phone: HTMLInputElement;
    protected readonly phone_error_msg: HTMLElement;
    protected readonly email_error_msg: HTMLElement;
    protected readonly accept: HTMLInputElement;
    protected readonly accept_msg: HTMLElement;
    protected readonly uploadDNA: HTMLInputElement;
    protected readonly country: HTMLInputElement;
    protected readonly country_error_msg: HTMLElement;

    //protected readonly url: string;
    protected  contenedor: HTMLElement;
    protected  botones: HTMLElement;
    protected solarCount: number =0;
    protected windCount: number =0;
    protected filaPrueba: HTMLElement;
    protected button_solar_err_msg: HTMLElement;
    protected button_wind_err_msg: HTMLElement;
    protected button_send_err_msg: HTMLElement;
    protected readonly url: string;
    //protected phoneInput: Element;
    // protected readonly molinos:HTMLElement;
    // protected readonly placas:HTMLElement;

    //Necesario para el envio y validacion
    protected contactForm: IContactForm ={
        name:'string',
        surename: 'string',
        company: 'string',
        position:'string',
        country:'string',
        phone: 'string',
        email: 'string',
        accept: false,
    };
    protected assetsSolar: IFTrialSolar[] =[];
    protected assetsWind: IFTrialWind[] =[];
    protected assetsDelivery: IFTrialDelivery[] = [];
    protected editButton: HTMLElement;
    protected confirmButton: HTMLElement;
    protected cancelButton:HTMLElement;
    protected editmsg:HTMLElement;
    protected totalInfo: IFtrialTotal = {
        contact: this.contactForm,
        solarAssets: this.assetsSolar,
        windAssets: this.assetsWind,
    };
    protected normalButtons: HTMLElement[];
    protected errorButtons: HTMLElement[];

    public constructor() {
        //DOM del boton enviar
        console.log("gets");
        //Span botonera
        this.bb1 = document.getElementById("bb1") as HTMLElement;
        this.bb2 = document.getElementById("bb2") as HTMLElement;
        this.bb3 = document.getElementById("bb3") as HTMLElement;
        this.bb4 = document.getElementById("bb4") as HTMLElement;

        //Botones
        this.b1 = document.getElementById("b1") as HTMLLIElement;
        this.b2 = document.getElementById("b2") as HTMLLIElement;
        this.b3 = document.getElementById("b3") as HTMLLIElement;
        this.b4 = document.getElementById("b4") as HTMLLIElement;
        //DOM del boton ADD SOLAR
        //Span botonera_solar
        this.bb1_solar = document.getElementById("bb1_add_solar") as HTMLElement;
        this.bb2_solar = document.getElementById("bb2_add_solar") as HTMLElement;
        this.bb3_solar = document.getElementById("bb3_add_solar") as HTMLElement;
        this.bb4_solar = document.getElementById("bb4_add_solar") as HTMLElement;

        //Botones_solar
        this.b1_solar = document.getElementById("b1_solar") as HTMLLIElement;
        this.b2_solar = document.getElementById("b2_solar") as HTMLLIElement;
        this.b3_solar = document.getElementById("b3_solar") as HTMLLIElement;
        this.b4_solar = document.getElementById("b4_solar") as HTMLLIElement;

        //DOM del boton ADD WIND
        //Span botonera_wind
        this.bb1_wind = document.getElementById("bb1_add_wind") as HTMLElement;
        this.bb2_wind = document.getElementById("bb2_add_wind") as HTMLElement;
        this.bb3_wind = document.getElementById("bb3_add_wind") as HTMLElement;
        this.bb4_wind = document.getElementById("bb4_add_wind") as HTMLElement;

        //Botones_wind
        this.b1_wind = document.getElementById("b1_wind") as HTMLLIElement;
        this.b2_wind = document.getElementById("b2_wind") as HTMLLIElement;
        this.b3_wind = document.getElementById("b3_wind") as HTMLLIElement;
        this.b4_wind = document.getElementById("b4_wind") as HTMLLIElement;

        //Formulario IContactForm
        this.name = document.getElementById('input_name') as HTMLInputElement;
        this.name_error_msg = document.getElementById('input_name_error_msg') as HTMLElement;
        this.surename = document.getElementById('input_surename') as HTMLInputElement;
        this.surename_error_msg = document.getElementById('input_surename_error_msg') as HTMLElement;
        this.company = document.getElementById('input_company') as HTMLInputElement;
        this.company_error_msg = document.getElementById('input_company_error_msg') as HTMLElement;
        this.position = document.getElementById('input_position') as HTMLInputElement;
        this.phone = document.getElementById('phone2') as HTMLInputElement;
        this.phone_error_msg = document.getElementById('phone_error_msg') as HTMLElement;
        this.email = document.getElementById('input_email') as HTMLInputElement;
        this.email_error_msg = document.getElementById('input_email_error_msg') as HTMLElement;
        this.country = document.getElementById("select_country") as HTMLInputElement;
        this.country_error_msg = document.getElementById("select_country_error_msg") as HTMLElement;
        this.accept = document.getElementById('input_accept') as HTMLInputElement;
        // @ts-ignore
        this.accept.parentElement.style.alignSelf = "center";
        this.accept_msg = document.getElementById('input_accept_msg') as HTMLElement;
        this.uploadDNA = document.getElementById('SDNA') as HTMLInputElement;
        //this.url = "";
        this.contenedor = document.getElementById('f_solar') as HTMLElement;
        this.botones = document.getElementById('fila-botones') as HTMLElement;
        this.button_solar_err_msg = document.getElementById('solarFailText') as HTMLElement;
        this.button_wind_err_msg = document.getElementById('windFailText') as HTMLElement;
        this.button_send_err_msg = document.getElementById('sendFailText') as HTMLElement;
        //Clonar un check con DOM
        this.filaPrueba = document.getElementById('fila-prueba') as HTMLElement;
        this.input0 = this.filaPrueba.getElementsByTagName('input')[0].cloneNode();
        this.svg0 = this.filaPrueba.getElementsByTagName('svg')[0].cloneNode(true);
        this.svg1 = this.filaPrueba.getElementsByTagName('svg')[1].cloneNode(true);
        this.labelCheck = this.filaPrueba.getElementsByTagName('label')[0].cloneNode();

        this.editButton = document.getElementById("editForm") as HTMLElement;
        this.confirmButton = document.getElementById("check") as HTMLElement;
        this.cancelButton = document.getElementById("deleteForm") as HTMLElement;
        let popupEdit: HTMLElement = <HTMLElement> document.getElementById("myPopupEdit") as HTMLElement;
        let popupCheck: HTMLElement = <HTMLElement> document.getElementById("myPopupCheck") as HTMLElement;
        let popupDelete: HTMLElement = <HTMLElement> document.getElementById("myPopupDelete") as HTMLElement;
        let blockText: HTMLElement = <HTMLElement> document.getElementById("blockText") as HTMLElement;
        this.editmsg = document.getElementById("editmsg") as HTMLElement;
        this.url= "";
        //this.coorInputRange();
        this.getPhoneParameters();
        this.normalButtons = [];
        this.errorButtons = [];
        this.accept_msg.innerHTML = 'I have read and accept the <a href="/legal-notice/" target="_blank">legal terms & conditions</a>'

        //**********************************************************************************************************************************************************************************
        //Para editar
        //1)Cuando pulse añadir parque al mismo tiempo que bloqueo el contacto debe haber otra que añada un lapiz al lado del titulo
        //2)Si pulso ese lapiz
            //2.1)Debe quitarse el bloqueo del container y permitir escribir
            //2.2)Debe bloquearse el último contenedor
                //2.2.1)Busco el ultimo asssetForm con la suma de contadores
                //2.2.2)Dentro de este busco si tiene algun delivery
                    //2.2.2.1)Si no tiene bloqueo el assetForm correspondiente
                    //2.2.2.2)Si tiene busco el último delivery y lo bloqueo
            //2.3)Debe cambiar el botón a uno que permita cancelar o confirmar
                //2.3.1)Puedo cancelar si hago un getForm del container conforme se pulsa el botón de lapiz(antes de que aparezcan los otros dos iconos)
                //2.3.2)Confirmar simplemente checkeara el contenedor de nuevo
                //2.3.3)Cuando pulse cualquiera de los dos desbloqueo el ultimo contenedor
        //3)Si es un parque como tendrá botón de eliminar eliminar el botón de eliminar hassta que termine de editar
        //4)Para los parques debemos desbloquear el botón de add delivery
            //4.1)Cuando desbloqueemos este boton de nuevo su función onClick() va a variar obtendrá el contenedor por parent
            //4.2)Creo una nueva botonera 3 para la siguiente
        //5)Cuando pulsen finalizar además de los pasos anteriores debo bloquear el botón de delivery de nuevo
        //**********************************************************************************************************************************************************************************

        //**********************************************************************************************************************************************************************************
        //Para Eliminar
        //1)Botón de borrado de assets
        //1.1)Guardo ese indicador para no leer ese assetForm en esta parte (!!**)
        //1.2)Borro el HTMLFORM
        //2)Boton de borrado de deliverys
        //2.2)Vale con unicamente borrar el form
        //**********************************************************************************************************************************************************************************

        //Pulse donde pulse vuelvo a setear el botón normal
            document.body.onclick = () =>{
                let errorButtons = document.getElementsByClassName('boton error');
                let normalButtons = document.getElementsByClassName('boton ampliado');
                for(let i =0; i<this.normalButtons.length;i++){
                    this.setNormalSelectButton(this.normalButtons[i] as HTMLElement,this.errorButtons[i] as HTMLElement);
                }
                this.normalButtons = [];
                this.errorButtons = [];
                for(let i =0; i<errorButtons.length;i++){
                    let parent = errorButtons[i].parentElement as HTMLElement
                    if(parent.style.display == 'flex'){
                        this.normalButtons[this.normalButtons.length] = normalButtons[i] as HTMLElement;
                        this.errorButtons[this.errorButtons.length] = errorButtons[i] as HTMLElement;
                    }
                }
            }
        this.editButton.onmouseenter = () =>{
            popupEdit.classList.toggle("show");
        };

        this.editButton.onmouseleave = () =>{
            popupEdit.classList.toggle("show");
        };

        this.cancelButton.onmouseenter = () =>{
            popupDelete.classList.toggle("show");
        };

        this.cancelButton.onmouseleave = () =>{
            popupDelete.classList.toggle("show");
        };

        this.confirmButton.onmouseenter = () =>{
            popupCheck.classList.toggle("show");
        };

        this.confirmButton.onmouseleave = () =>{
            popupCheck.classList.toggle("show");
        };

        this.editButton.onclick = () =>{
            //Aparece el texto de editado
            this.editmsg.style.display = 'flex';
            //Aparecen los botones de confirmar y cancelar
            this.editButton.style.display = 'none'
            this.cancelButton.style.display = 'flex'
            this.confirmButton.style.display = 'flex'

            //Bloqueo todos los botnoes de delivery o delete de los demás bloques
            let configureButtons = document.getElementsByClassName("popup");
            for(let i =0; i<configureButtons.length;i++){
                let icons =configureButtons[i].getElementsByTagName("b");
                if(icons.length > 1){
                    icons[0].style.display = 'none';
                }
            }

            //Bloqeo los botones para continuar hasta que esté editado o cancelado
            this.setBlockDeliveryButton(this.bb1_wind,this.bb2_wind,this.bb4_wind)
            this.setBlockDeliveryButton(this.bb1_solar,this.bb2_solar,this.bb4_solar)
            this.setBlockDeliveryButton(this.bb1,this.bb2,this.bb4)
            let containers = document.getElementsByClassName('w3-container');
            if(containers.length>1){
                let buttons = containers[containers.length-1].getElementsByClassName('botonera')
                this.setBlockDeliveryButton(buttons[0] as HTMLElement,buttons[1] as HTMLElement,buttons[2] as HTMLElement)

                //bloquear el ultimo container que estuviera configurando
                let lastAsset = containers[containers.length-1] as HTMLElement;
                let deliverys = lastAsset.getElementsByClassName('contenedor');

                //Si tiene deliverys activamos el último delivery
                if(deliverys.length >0){
                    this.disableContainer(deliverys[deliverys.length-1] as HTMLElement);
                }//Si no es la configuración del último asset lo que debemos activar
                else{
                    this.disableContainer(lastAsset);
                }
            }

            blockText.innerText = "Please finish editing the current form before continuing."

            //Desbloqueo el container sobre el que quiere editar
            this.enableContainer(document.getElementById("f1") as HTMLElement)

            //Guardo una copia de seguridad por si cancelan
            this.contactForm = this.getFormValuesMain();
        }

        this.cancelButton.onclick = () =>{
            //Vuelvo a cargar el botón de editar
            this.editButton.style.display = 'flex'
            this.cancelButton.style.display = 'none'
            this.confirmButton.style.display = 'none'
            //Desaparece el texto de editado
            this.editmsg.style.display = 'none';
            //Recupero los valores del form
            this.name.value = this.contactForm.name;
            this.surename.value = this.contactForm.surename;
            this.company.value = this.contactForm.company;
            this.position.value = this.contactForm.position;
            this.country.value = this.contactForm.country;
            this.phone.value = this.contactForm.phone;
            this.accept.checked = true;
            this.email.value = this.contactForm.email;

            //Desactivo el container que se estaba editando
            this.disableContainer(document.getElementById("f1") as HTMLElement)

            //Quito las marcas de error
            this.aproveContainer((document.getElementById('f1') as HTMLElement));

            let containers = document.getElementsByClassName('w3-container');
            if(containers.length >1){
                //Vuelvo a activar el último container de la lista
                let lastAsset = containers[containers.length-1] as HTMLElement
                let deliverys = lastAsset.getElementsByClassName('contenedor');
                //Si tiene deliverys activamos el último delivery
                if(deliverys.length >0){
                    this.enableContainer(deliverys[deliverys.length-1] as HTMLElement);
                }//Si no es la configuración del último asset lo que debemos activar
                else{
                    this.enableContainer(lastAsset);
                }
                let buttons = containers[containers.length-1].getElementsByClassName('boton ampliado');
                let buttonsBlock = containers[containers.length-1].getElementsByClassName('boton block')

                this.setNormalDeliveryButton(buttons[0] as HTMLElement,buttonsBlock[0] as HTMLElement);
                //Desbloqueo todos los botnoes de delivery o delete de los demás bloques
                let configureButtons = document.getElementsByClassName("popup");
                for(let i =0; i<configureButtons.length;i++){
                    let icons =configureButtons[i].getElementsByTagName("b");
                    if(icons.length > 1 && i<configureButtons.length-2){
                        icons[0].style.display = 'flex';
                    }else{
                        //Si es el primer contenedor no tengo que activar el último botón
                        if (deliverys.length == 1) {
                            if(i == configureButtons.length-2){
                                icons[0].style.display = 'flex';
                            }
                        }//Si el ultimo contenedor no es el primer delivery desbloqueo el penúltimo (Edit)
                        else if (i == configureButtons.length-1){
                            icons[0].style.display = 'flex';
                        }
                    }
                }
            }
            this.setNormalButton();
        }


        this.confirmButton.onclick = () =>{
            //Revisar el container antes de cerrarlo
             this.processCheckContactForm().then(async () => {
                 //Vuelvo a cargar el botón de editar
                 this.editButton.style.display = 'flex'
                 this.cancelButton.style.display = 'none'
                 this.confirmButton.style.display = 'none'
                 //Desaparece el texto de editado
                 this.editmsg.style.display = 'none';
                 this.setNormalButton();
                 //Desactivo el container que se estaba editando
                 this.disableContainer((document.getElementById('f1') as HTMLElement));
                 this.aproveContainer((document.getElementById('f1') as HTMLElement));
                 this.editButton.style.display = 'flex';
                 //Vuelvo a activar el último container de la lista
                 let containers = document.getElementsByClassName('w3-container');
                 if(containers.length>1){
                     let lastAsset = containers[containers.length-1] as HTMLElement
                     let deliverys = lastAsset.getElementsByClassName('contenedor');
                     //Si tiene deliverys activamos el último delivery
                     if(deliverys.length >0){
                         this.enableContainer(deliverys[deliverys.length-1] as HTMLElement);
                     }//Si no es la configuración del último asset lo que debemos activar
                     else{
                         this.enableContainer(lastAsset);
                     }
                     let buttons = lastAsset.getElementsByClassName('boton ampliado')
                     let buttonsBlock = lastAsset.getElementsByClassName('boton block')
                     this. setNormalDeliveryButton(buttons[0] as HTMLElement,buttonsBlock[0] as HTMLElement);
                     //Desbloqueo todos los botnoes de delivery o delete de los demás bloques
                     let configureButtons = document.getElementsByClassName("popup");
                     for(let i =0; i<configureButtons.length;i++){
                         let icons =configureButtons[i].getElementsByTagName("b");
                         if(icons.length > 1 && i<configureButtons.length-2){
                             icons[0].style.display = 'flex';
                         }else{
                             //Si es el primer contenedor no tengo que activar el último botón
                             if (deliverys.length == 1) {
                                 if(i == configureButtons.length-2){
                                     icons[0].style.display = 'flex';
                                 }
                             }//Si el ultimo contenedor no es el primer delivery desbloqueo el penúltimo (Edit)
                             else if (i == configureButtons.length-1){
                                 icons[0].style.display = 'flex';
                             }
                         }
                     }
                 }
                 //Guardo una copia de seguridad por si cancelan
                 this.contactForm = this.getFormValuesMain();
             }).catch(async (err) => {
                 //Si no cumple botón en rojo, subraya fallos y no crea el form
                 this.contactFailed();
                 console.log("Error sending form", err);
             });
        }

        //Si añaden parque de solar
        this.b1_solar.onclick = this.b2_solar.onclick = this.b3_solar.onclick = () => {
            //Nos indica si tiene que validar el panel de contact(si es el primer parque) o el ultimo parque insertado
            let containers = document.getElementsByClassName('w3-container');

            if (containers.length <= 1) {
                //revisa form si el contact está ok y permite enviar y crea nuevo chart solar
                this.processCheckContactForm().then(async () => {
                    this.setNormalButton();
                    this.disableContainer((document.getElementById('f1') as HTMLElement));
                    this.aproveContainer((document.getElementById('f1') as HTMLElement));
                    this.editButton.style.display = 'flex';
                    this.newSolarForm();
                //Si no cumple botón en rojo, subraya fallos y no crea el form
                }).catch(async (err) => {
                    this.setErrorButton_Add_Solar();
                    console.log("Error sending form", err);
                });
            //Si es el segundo parque tenemos que validar en su lugar el ultimo container de delivery del parque anterior
            }else{
                let deliverys = containers[containers.length-1].getElementsByClassName('contenedor')
                //SI tiene deliverys revisamos el último
                if(deliverys.length > 0) {
                    if(deliverys.length > 1){
                        let editButton = deliverys[deliverys.length-1].getElementsByTagName('b');
                        editButton[0].style.display = 'flex';
                    }else{
                        let editButton = deliverys[deliverys.length-1].getElementsByTagName('b');
                        editButton[2].style.display = 'flex';
                    }
                    this.processCheckDeliveryForm(deliverys[deliverys.length - 1] as HTMLElement).then(async () => {
                        //bloqueo el ultimo delivery button
                        let buttons = containers[containers.length-1].getElementsByClassName('botonera');
                        this.setBlockDeliveryButton(buttons[0] as HTMLElement,buttons[1] as HTMLElement,buttons[2] as HTMLElement);
                        this.setNormalButton();
                        this.aproveContainer(deliverys[deliverys.length - 1] as HTMLElement);
                        this.disableContainer(deliverys[deliverys.length - 1] as HTMLElement);
                        this.newSolarForm();
                    }).catch(async (err) => {
                        this.setErrorButton_Add_Solar();
                        console.log("Error sending form", err);
                    });
                //Si no tiene le decimos al cliente que debe tener al menos uno
                }else{
                    this.button_solar_err_msg.innerText = "Insert at least one delivery for your last asset"
                    this.setErrorButton_Add_Solar();
                }
            }
        }

        //Si añaden parque de viento
        this.b1_wind.onclick = this.b2_wind.onclick = this.b3_wind.onclick = () => {
            let containers = document.getElementsByClassName('w3-container');
            //Nos indica si tiene que validar el panel de contact o el ultimo parque insertado
            if (containers.length <=1) {
                //revisa form si el contact está ok y permite enviar y crea nuevo chart viento
                this.processCheckContactForm().then(async () => {
                    this.setNormalButton();
                    this.disableContainer((document.getElementById('f1') as HTMLElement));
                    this.editButton.style.display = 'flex';
                    this.newWindForm();
                }).catch(async (err) => {
                    this.setErrorButton_Add_Wind();
                    console.log("Error sending form", err);
                });
            //Si es el segundo parque
            }else{
                let containers = document.getElementsByClassName('w3-container');
                let deliverys = containers[containers.length-1].getElementsByClassName('contenedor')
                //SI tiene deliverys revisamos el último
                if(deliverys.length > 0) {
                    if(deliverys.length > 1){
                        let editButton = deliverys[deliverys.length-1].getElementsByTagName('b');
                        editButton[0].style.display = 'flex';
                    }else{
                        let editButton = deliverys[deliverys.length-1].getElementsByTagName('b');
                        editButton[2].style.display = 'flex';
                    }
                    this.processCheckDeliveryForm(deliverys[deliverys.length - 1] as HTMLElement).then(async () => {
                        //bloqueo el ultimo delivery button
                        let buttons = containers[containers.length-1].getElementsByClassName('botonera')
                        this.setBlockDeliveryButton(buttons[0] as HTMLElement,buttons[1] as HTMLElement,buttons[2] as HTMLElement);
                        this.setNormalButton();
                        this.aproveContainer(deliverys[deliverys.length - 1] as HTMLElement);
                        this.disableContainer(deliverys[deliverys.length - 1] as HTMLElement);
                        this.newWindForm();
                    }).catch(async (err) => {
                        this.setErrorButton_Add_Wind();
                        console.log("Error sending form", err);
                    });
                    //Si no tiene le decimos al cliente que debe tener al menos uno
                }else{
                    this.button_wind_err_msg.innerText = "Insert at least one delivery for your last asset"
                    this.setErrorButton_Add_Wind();
                }
            }
        }

        //Boton de envio
        this.b1.onclick = this.b2.onclick = this.b3.onclick = () => {
            //Cuando el cliente pulsa enviar
                //1)Comprobar si el último parque tiene delivery
                //2)Comprobar que el ultimo delivery de este parque es correcto
                //3)recogemos el form contact
                //4)Comprobando los header de cada "AssetForm"+id
                    //4.1)Recogemos todos los datos de solar
                    //4.2)Recogemos todos los datos de viento
                //5)Montamos la interfaz con toda la info recogida
                //6)Manda un correo con los datos necesarios
                //7)La página cambia a un panel en el que solo nos dice que toodo ha ido correcto y que le contactaremos cuando todo esté configurado
                //8)Mandamos un correo al cliente con la confirmación del proceso
            //1)Comprobar si el último parque tiene delivery
            let forms = document.getElementsByClassName('w3-container');
            let containers = forms[forms.length-1].getElementsByClassName('contenedor')
            //SI tiene deliverys revisamos el último
            if(containers.length > 0) {
                //2)Comprobar que el ultimo delivery de este parque es correcto
                this.processCheckDeliveryForm(containers[containers.length - 1] as HTMLElement).then(async () => {
                    //Si todo esta bien borramos los errores anteriores
                    this.setNormalButton();
                    this.disableContainer((document.getElementById('f1') as HTMLElement));
                    this.aproveContainer(containers[containers.length - 1] as HTMLElement);
                    this.disableContainer(containers[containers.length - 1] as HTMLElement);
                    //3)recogemos el form contact
                    this.contactForm = this.getFormValuesMain();
                    let solarformcount =0;
                    let windformcount = 0;
                    let assets = document.getElementsByClassName('w3-container');
                    //4)Comprobando los header de cada "AssetForm"+id
                    //Me salto el primer contenedor porque es el contacto
                    for(let i =1; i< assets.length;i++){
                        //Aqui comprobar si algunindice se ha borrado !!**
                        let headers = assets[i].getElementsByTagName('h2')
                        // @ts-ignore
                        if(headers[0].textContent.slice(0,3)== 'Sol'){
                            //Sacamos los deliverys del parque
                            let deliverys = assets[i].getElementsByClassName('contenedor')
                            for(let j= 0;j<deliverys.length; j++){
                                this.assetsDelivery[j]= this.getFormValuesDelivery(deliverys[j] as HTMLElement);
                            }
                            //4.1)Recogemos todos los datos de solar
                            this.assetsSolar[solarformcount] = this.getFormValuesSolar(assets[i] as HTMLElement,this.assetsDelivery);
                            solarformcount +=1;
                            this.assetsDelivery =[];
                        }

                        // @ts-ignore
                        if(headers[0].textContent.slice(0,3)== 'Win'){
                            //Sacamos los deliverys del parque
                            let deliverys = assets[i].getElementsByClassName('contenedor')
                            for(let j= 0;j<deliverys.length; j++){
                                this.assetsDelivery[j]= this.getFormValuesDelivery(deliverys[j] as HTMLElement);
                            }
                            //4.2)Recogemos todos los datos de viento
                            this.assetsWind[windformcount] = this.getFormValuesWind(assets[i] as HTMLElement,this.assetsDelivery);
                            windformcount +=1
                            this.assetsDelivery =[];
                        }
                    }
                    //5)Montamos la interfaz con toda la info recogida
                    this.totalInfo ={
                        contact: this.contactForm,
                        windAssets: this.assetsWind,
                        solarAssets: this.assetsSolar
                    }
                    //6)Manda un correo con los datos necesarios
                    this.sendMail(this.totalInfo);
                    this.sendMailClient(this.totalInfo);
                    //7)Creo la pantalla de confirmacion
                    this.confirmProcess(this.totalInfo.contact.email);
                }).catch(async (err) => {
                    this.setErrorButton();
                    console.log("Error sending form", err);
                });
                //Si no tiene le decimos al cliente que debe tener al menos uno
            }else{
                this.button_send_err_msg.innerText = "Insert at least one delivery for your last asset"
                this.setErrorButton();
            }


            // this.processSendMail().then(async () => {
            //     this.setSuccessButton();
            // }).catch(async (err) => {
            //     this.setErrorButton();
            //     console.log("Error sending form", err);
            // });
        }

    }

    private async sendMail(form : IFtrialTotal): Promise<void> {
        let Mail = this.createMail(form);

        const {status, data} = await axios.get<IRespuesta<void>>(`/web/mailTrial/`, {
            params: {
                contact: Mail.contact,
                windAssets: Mail.windAssets,
                solarAssets: Mail.solarAssets
            }
        }).catch(async (err)=>{
            if (axios.isAxiosError(err)) {
                if (err.response != undefined) {
                    return Promise.reject(err.response.statusText);
                }
                if (err.request!=undefined) {
                    return Promise.reject(err.request);
                }
                return Promise.reject(err.message);
            }
            return Promise.reject(err);
        });

        if (status!=200 || !data.ok) {
            return Promise.reject(data);
        }
    }

    private async sendMailClient(form : IFtrialTotal): Promise<void> {

        const {status, data} = await axios.get<IRespuesta<void>>(`/web/mailClientTrial/`, {
            params: {
                contact: form.contact.email,
                name: form.contact.name
            }
        }).catch(async (err)=>{
            if (axios.isAxiosError(err)) {
                if (err.response != undefined) {
                    return Promise.reject(err.response.statusText);
                }
                if (err.request!=undefined) {
                    return Promise.reject(err.request);
                }
                return Promise.reject(err.message);
            }
            return Promise.reject(err);
        });

        if (status!=200 || !data.ok) {
            return Promise.reject(data);
        }
    }

    private async getPhoneParameters(): Promise<void> {
        let input = document.querySelector("#phone2") as HTMLInputElement,
            errorMsg = document.querySelector("#error-msg") as HTMLElement,
            validMsg = document.querySelector("#valid-msg") as HTMLElement;
        let IpInfo = await this.getIpInfo();
        let errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
        let iti = window.intlTelInput(input, {
            initialCountry: IpInfo.country,
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.15/js/utils.js",
        });
        //wefwfwwd
        let reset = function () {
            input.classList.remove("error");
            errorMsg.innerHTML = "";
            validMsg.innerHTML = "";
            errorMsg.classList.add("hide");
            validMsg.classList.add("hide");
        };

        // on keyup / change flag: reset
        input.addEventListener('change', reset);
        input.addEventListener('keyup', reset);
        // on blur: validate
        input.addEventListener('blur', function () {
            reset();
            if (input.value.trim()) {
                if (iti.isValidNumber()) {
                    validMsg.innerHTML = "&check; Valid";
                    validMsg.classList.remove("hide");
                } else {
                    input.classList.add("error");
                    var errorCode = iti.getValidationError();
                    errorMsg.innerHTML = errorMap[errorCode];
                    errorMsg.classList.remove("hide");
                    errorMsg.style.color = '#d0021b'
                }
            }
        });
    }

    private createMail(form : IFtrialTotal): IMail {
        let wind: any = '';
        let solar: any = '';
        let contact: any = `<h2>Contact info:</h2>
                                <p>Name: ${form.contact.name} ${form.contact.surename}</p>
                                <p>Company: ${form.contact.company}</p>
                                <p>Position: ${form.contact.position}</p>
                                <p>Country: ${form.contact.country}</p>
                                <p>Phone: ${form.contact.phone}</p>
                                <p>Email: ${form.contact.email}</p>`
        for(let i=0; i<form.windAssets.length; i++){
            wind += `<h2>Wind Asset ${i}</h2>
                      <p>Name: ${form.windAssets[i].nameStation}</p>
                      <p>Location: ${form.windAssets[i].location}</p>
                      <p>Latitude: ${form.windAssets[i].latitude}</p>
                      <p>Longitude: ${form.windAssets[i].longitude}</p>
                      <p>Nominal: ${form.windAssets[i].nominal}</p>
                      <p>Power: ${form.windAssets[i].power}</p>
                      <p>Wind: ${form.windAssets[i].wind}</p>
                      <p>Direction: ${form.windAssets[i].direction}</p>
                      <p>Pression: ${form.windAssets[i].pression}</p>`
            for(let j =0; j<form.windAssets[i].delivery.length; j++){
                wind+= `<h3>Delivery ${j}</h3>
                      <p>Delivery Each: ${form.windAssets[i].delivery[j].delivery_each}</p>
                      <p>Start Hour: ${form.windAssets[i].delivery[j].start_hour}</p>
                      <p>Time Stamp:${form.windAssets[i].delivery[j].timeStamp}</p>
                      <p>Resolution: ${form.windAssets[i].delivery[j].resolution}</p>
                      <p>CSV: ${form.windAssets[i].delivery[j].csv}</p>
                      <p>XLS: ${form.windAssets[i].delivery[j].xls}</p>
                      <p>FTP: ${form.windAssets[i].delivery[j].ftp}</p>
                      <p>API: ${form.windAssets[i].delivery[j].api}</p>
                      <p>Mail: ${form.windAssets[i].delivery[j].email}</p>`
            }
        }

        for(let i=0; i<form.solarAssets.length; i++){
            solar += `<h2>Solar Asset ${i}</h2>
                      <p>Name: ${form.solarAssets[i].nameStation}</p>
                      <p>Position: ${form.solarAssets[i].location}</p>
                      <p>Country: ${form.solarAssets[i].latitude}</p>
                      <p>Longitude: ${form.solarAssets[i].longitude}</p>
                      <p>Ac: ${form.solarAssets[i].ac}</p>
                      <p>Dc: ${form.solarAssets[i].dc}</p>
                      <p>TrackingType: ${form.solarAssets[i].trackingType}</p>
                      <p>COD: ${form.solarAssets[i].COD}</p>
                      <p>Power: ${form.solarAssets[i].power}</p>
                      <p>Temperature: ${form.solarAssets[i].temperature}</p>
                      <p>GHI: ${form.solarAssets[i].GHI}</p>
                      <p>DHI: ${form.solarAssets[i].DHI}</p>
                      <p>DNI: ${form.solarAssets[i].DNI}</p>
                      <p>Cloud coverage: ${form.solarAssets[i].cloud}</p>`
            for(let j =0; j<form.solarAssets[i].delivery.length; j++){
                solar+= `<h3>Delivery ${j}</h3>
                      <p>Delivery Each: ${form.solarAssets[i].delivery[j].delivery_each}</p>
                      <p>Start Hour: ${form.solarAssets[i].delivery[j].start_hour}</p>
                      <p>Time Stamp:${form.solarAssets[i].delivery[j].timeStamp}</p>
                      <p>Resolution: ${form.solarAssets[i].delivery[j].resolution}</p>
                      <p>CSV: ${form.solarAssets[i].delivery[j].csv}</p>
                      <p>XLS: ${form.solarAssets[i].delivery[j].xls}</p>
                      <p>FTP: ${form.solarAssets[i].delivery[j].ftp}</p>
                      <p>API: ${form.solarAssets[i].delivery[j].api}</p>
                      <p>Mail: ${form.solarAssets[i].delivery[j].email}</p>`
            }
        }
        return {
            contact: contact,
            windAssets: wind,
            solarAssets: solar}
    }

    private async processCheckContactForm(): Promise<void> {
        const form = this.getFormValuesMain();

        if ((!form.accept || form.email.length == 0 || !emailRegex.test(form.email) || form.name.length == 0 || form.surename.length == 0 || form.company.length == 0 || form.country == "--Select Country--" ||  this.phone.className == 'texto texto-2 error' || form.phone.length == 0)  && form.name != 'admin')  {
            return Promise.reject("You must accept Legal terms and indicate an email");
        }
    }

    private async processCheckAssetForm(): Promise<void> {
        //validaciones solar
        //1) Todos los inputs seteados
        //2) Al menos una variable seteada
        //3) Se valida cuando se pulsa Add delivery
        let error = false;
        let checks = false;
        let containers = document.getElementsByClassName('w3-container');
        let inputs = containers[containers.length-1].getElementsByTagName('input')
        for(let i = 0; i<inputs.length; i++){
            if(inputs[i].type != 'checkbox' && i != 1){
                //El campo COD no es obligatorio asi que omito date
                if(inputs[i].value.length == 0 && inputs[i].type != 'date'){
                    error = true
                    inputs[i].className = 'texto texto-2 error';
                    // @ts-ignore
                    document.getElementById(inputs[i].id+'_error_msg' as HTMLElement).innerHTML = 'this field is required';
                }else{
                    inputs[i].className = 'texto texto-2';
                    // @ts-ignore
                    document.getElementById(inputs[i].id+'_error_msg' as HTMLElement).innerHTML = '';
                }
            }else{
                if(inputs[i].checked){
                    checks = true;
                }
            }
        }

        if(!checks){

            let labels = containers[containers.length-1].getElementsByTagName('label');
            if(labels[8].innerHTML == 'Available variables (please select at least one)' || labels[8].innerHTML == 'Available variables *') {
                labels[8].className = 'msg-error texto-2'
                labels[8].innerHTML = 'Available variables (please select at least one)'
            }else{
                labels[5].className = 'msg-error texto-2'
                labels[5].innerHTML = 'Available variables (please select at least one)'
            }
            error = true;
        }else{
            let labels = containers[containers.length-1].getElementsByTagName('label');
            if(labels[8].innerHTML == 'Available variables (please select at least one)' || labels[8].innerHTML == 'Available variables *') {
                labels[8].className = 'texto-2'
                labels[8].innerHTML = 'Available variables *'
            }else{
                labels[5].className = 'texto-2'
                labels[5].innerHTML = 'Available variables *'
            }
        }
        if(inputs[0].value == 'admin'){
            error = false;
        }
        if(error){
            return Promise.reject("You must check all mandatory fields");
        }
    }

    private async processCheckYourForm(form: HTMLElement): Promise<void> {
        //validaciones solar
        //1) Todos los inputs seteados
        //2) Al menos una variable seteada
        //3) Se valida cuando se pulsa Add delivery
        let error = false;
        let checks = false;
        let inputs = form.getElementsByTagName('input');

        //-7 (Descarto los inputs del delivery)
        let deliverys = form.getElementsByClassName('contenedor');
        let inputLength = inputs.length - (deliverys.length*7);

        for(let i = 0; i<inputLength ; i++){
            if(inputs[i].type != 'checkbox' && i != 1) {
                //El campo COD no es obligatorio asi que omito date
                if(inputs[i].value.length == 0 && inputs[i].type != 'date'){
                    error = true
                    inputs[i].className = 'texto texto-2 error';
                    // @ts-ignore
                    document.getElementById(inputs[i].id+'_error_msg' as HTMLElement).innerHTML = 'this field is required';
                }else{
                    inputs[i].className = 'texto texto-2';
                    // @ts-ignore
                    document.getElementById(inputs[i].id+'_error_msg' as HTMLElement).innerHTML = '';
                }
            }else{
                if(inputs[i].checked){
                    checks = true;
                }
            }
        }

        if(!checks){
            let labels = form.getElementsByTagName('label');
            if(labels[8].innerHTML == 'Available variables (please select at least one)' || labels[8].innerHTML == 'Available variables *') {
                labels[8].className = 'msg-error texto-2'
                labels[8].innerHTML = 'Available variables (please select at least one)'
            }else{
                labels[5].className = 'msg-error texto-2'
                labels[5].innerHTML = 'Available variables (please select at least one)'
            }
            error = true;
        }else{
            let labels = form.getElementsByTagName('label');
            if(labels[8].innerHTML == 'Available variables (please select at least one)' || labels[8].innerHTML == 'Available variables *') {
                labels[8].className = 'texto-2'
                labels[8].innerHTML = 'Available variables *'
            }else{
                labels[5].className = 'texto-2'
                labels[5].innerHTML = 'Available variables *'
            }
        }
        if(inputs[0].value == 'admin'){
            error = false;
        }
        if(error){
            return Promise.reject("You must check all mandatory fields");
        }
    }

    private async processCheckDeliveryForm(delivery: HTMLElement): Promise<void> {
        let error = false;
        let checkFormat = false;
        let checkDelivery = false;
        let inputs = delivery.getElementsByTagName('input')
        for(let i = 0; i<inputs.length; i++){
            if(inputs[i].type != 'checkbox') {
                if(inputs[i].value.length == 0){
                    error = true
                    inputs[i].className = 'texto texto-2 error';
                    // @ts-ignore
                    document.getElementById(inputs[i].id+'_error_msg' as HTMLElement).innerHTML = 'this field is required';
                }else{
                    inputs[i].className = 'texto texto-2';
                    // @ts-ignore
                    document.getElementById(inputs[i].id+'_error_msg' as HTMLElement).innerHTML = '';
                }
            }else{
                if(inputs[i].checked && i >=2 && i <=3){
                    checkFormat = true;
                }
                if(inputs[i].checked && i >=4 && i <=6){
                    checkDelivery = true;
                }
            }
        }
        let selects = delivery.getElementsByTagName('select');
        for(let i = 0; i<selects.length; i++){
            let select = selects[i];
            if(select.value == '--Select frequency--' || select.value == '--Select timestamp--'){
                selects[i].className = 'texto texto-2 error';
                // @ts-ignore
                document.getElementById(selects[i].id+'_error_msg' as HTMLElement).innerHTML = 'this field is required';
            }else{
                selects[i].className = 'texto-2';
                // @ts-ignore
                document.getElementById(selects[i].id+'_error_msg' as HTMLElement).innerHTML = '';
            }
        }

        if(!checkFormat){
            let labels = delivery.getElementsByTagName('label');
            labels[4].className = 'msg-error texto-2'
            labels[4].innerHTML = 'Formats (Please select at least one)'
            error = true;
        }else{
            let labels = delivery.getElementsByTagName('label');
            labels[4].className = 'texto-2'
            labels[4].innerHTML = 'Formats (After selection you can request a custom format by sending us an e-mail)'
        }

        if(!checkDelivery){
            let labels = delivery.getElementsByTagName('label');
            labels[5].className = 'msg-error texto-2'
            labels[5].innerHTML = 'Delivery (Please select at least one)'
            error = true;
        }else{
            let labels = delivery.getElementsByTagName('label');
            labels[5].className = 'texto-2'
            labels[5].innerHTML = 'Delivery'
        }
        if(inputs[1].value == '666'){
            error = false;
        }

        if(error){
            return Promise.reject("You must check all mandatory fields");
        }
    }

    //IContactForm
    private getFormValuesMain(): IContactForm {
        return {
            name: this.name?.value??"",
            surename: this.surename?.value??"",
            email: this.email?.value??"",
            company: this.company?.value??"",
            position: this.position?.value??"",
            country: this.country?.value??"",
            phone: this.phone?.value??"",
            accept: this.accept?.checked??false,
        }
    }

    private getFormValuesDelivery(assetContainer: HTMLElement): IFTrialDelivery {
        let inputs = assetContainer.getElementsByTagName('input');
        let selects = assetContainer.getElementsByTagName('select');
        return {
            delivery_each: selects[0].value,
            start_hour: inputs[0].value,
            timeStamp: selects[1].value,
            resolution: inputs[1].value,
            csv: inputs[2].checked,
            xls: inputs[3].checked,
            ftp: inputs[4].checked,
            api: inputs[5].checked,
            email: inputs[6].checked,
        }
    }

    //ISolarForm
    private getFormValuesSolar(assetContainer: HTMLElement,deliverys: IFTrialDelivery[]): IFTrialSolar {
        let inputs = assetContainer.getElementsByTagName('input');
        let selects = assetContainer.getElementsByTagName('select');
        return {
            nameStation: inputs[0].value,
            location: inputs[1].value,
            latitude: inputs[2].value,
            longitude: inputs[3].value,
            ac: inputs[4].value,
            dc: inputs[5].value,
            trackingType: selects[0].value,
            COD:inputs[6].value,
            power:inputs[7].checked,
            temperature: inputs[8].checked,
            GHI: inputs[9].checked,
            DNI: inputs[10].checked,
            DHI: inputs[11].checked,
            cloud: inputs[12].checked,
            delivery: deliverys,
        }
    }

    //IWindForm
    private getFormValuesWind(assetContainer: HTMLElement,deliverys: IFTrialDelivery[]): IFTrialWind {
        let inputs = assetContainer.getElementsByTagName('input');
        return {
            nameStation: inputs[0].value,
            location: inputs[1].value,
            latitude: inputs[2].value,
            longitude: inputs[3].value,
            nominal: inputs[4].value,
            power: inputs[5].checked,
            wind: inputs[6].checked,
            direction: inputs[7].checked,
            pression: inputs[8].checked,
            delivery: deliverys,
        }
    }

    private  async getIpInfo(): Promise<IPInfo>{
        // @ts-ignore
        const {status, data} =  await axios.get<IRespuesta<void>>(`https://ipapi.co/json/`, {}).catch(async (err) => {
        }).catch(async (err) => {
            let IpInfoBad={
                ip: null,
                network: null,
                version: null,
                city: null,
                region: null,
                region_code: null,
                country: 'IT',
                country_name: null,
                country_code: null,
                country_calling_code: null,
                country_code_iso3: null,
                country_capital: null,
                country_tld: null,
                continent_code: null,
                in_eu: null,
                postal: null,
                latitude: null,
                longitude: null,
                timezone: null,
                utc_offset: null,
                currency: null,
                currency_name: null,
                languages: null,
                country_area: null,
                country_population: null,
                asn: null,
                org: null,
            }
            if (axios.isAxiosError(err)) {
                 if (err.response != undefined) {
                     return Promise.reject(err.response.statusText);
                 }
                 if (err.request != undefined) {
                     return Promise.reject(err.request);
                 }
                 return Promise.reject(err.message);
            }
            return IpInfoBad;
        });
        let IpInfo={
            ip: data.ip,
            network: data.network,
            version: data.version,
            city: data.city,
            region: data.region,
            region_code: data.region_code,
            country: data.country,
            country_name: data.country_name,
            country_code: data.country_code,
            country_calling_code: data.country_calling_code,
            country_code_iso3: data.country_code_iso3,
            country_capital: data.country_capital,
            country_tld: data.country_tld,
            continent_code: data.continent_code,
            in_eu: data.in_eu,
            postal: data.postal,
            latitude: data.latitude,
            longitude: data.longitude,
            timezone: data.timezone,
            utc_offset: data.utc_offset,
            currency: data.currency,
            currency_name: data.currency_name,
            languages: data.languages,
            country_area: data.country_area,
            country_population: data.country_population,
            asn: data.asn,
            org: data.org
        }
        return IpInfo
    }

    private setErrorButton(): void {
        this.bb1.style.display = 'none'
        this.bb2.style.display = 'flex';
        this.bb3.style.display = 'none';
        this.bb4.style.display = 'none';
    }

    private setErrorButton_Add_Solar(): void {
        let containers = document.getElementsByClassName('w3-container');
        if(containers.length <=1){
            this.contactFailed();
        }
        this.bb1_solar.style.display = 'none'
        this.bb2_solar.style.display = 'flex';
        this.bb3_solar.style.display = 'none';
    }

    private setErrorButton_Add_Wind(): void {
        let containers = document.getElementsByClassName('w3-container');
        if(containers.length <= 1){
            this.contactFailed();
        }
        this.bb1_wind.style.display = 'none'
        this.bb2_wind.style.display = 'flex';
        this.bb3_wind.style.display = 'none';
        this.bb4_wind.style.display = 'none';
    }

    private setErrorButton_Add_Delivery(button: HTMLElement, buttonError: HTMLElement): void {
        // @ts-ignore
        button.parentElement.style.display = 'none'
        // @ts-ignore
        buttonError.parentElement.style.display = 'flex';
    }

    private setNormalDeliveryButton(button: HTMLElement, buttonError: HTMLElement): void {
        let containers = document.getElementsByClassName('w3-container');
        let labels = containers[containers.length-1].getElementsByTagName('label');
        if(labels[8].innerHTML == 'Available variables (please select at least one)' || labels[8].innerHTML == 'Available variables *') {
            labels[8].className = 'texto-2'
            labels[8].innerHTML = 'Available variables *'
        }else{
            labels[5].className = 'texto-2'
            labels[5].innerHTML = 'Available variables *'
        }

        // @ts-ignore
        button.parentElement.style.display = 'flex';
        // @ts-ignore
        buttonError.parentElement.style.display = 'none';
    }
    private setNormalSelectButton(button: HTMLElement, buttonError: HTMLElement): void {
        // @ts-ignore
        button.parentElement.style.display = 'flex';
        // @ts-ignore
        buttonError.parentElement.style.display = 'none';
    }

    private setBlockDeliveryButton(button: HTMLElement,buttonError:HTMLElement,buttonBlock:HTMLElement): void {
        // @ts-ignore
        button.style.display = 'none';
        // @ts-ignore
        buttonError.style.display = 'none';
        // @ts-ignore
        buttonBlock.style.display = 'flex';
    }

    private setNormalButton(): void {
        this.email.className = 'texto texto-2';
        this.email_error_msg.innerText = "";

        this.accept.className = 'texto-2';

        this.bb1.style.display = 'flex';
        this.bb2.style.display = 'none';
        this.bb3.style.display = 'none';
        this.bb4.style.display = 'none';

        this.bb1_solar.style.display = 'flex';
        this.bb2_solar.style.display = 'none';
        this.bb3_solar.style.display = 'none';
        this.bb4_solar.style.display = 'none';

        this.bb1_wind.style.display = 'flex';
        this.bb2_wind.style.display = 'none';
        this.bb3_wind.style.display = 'none';
        this.bb4_wind.style.display = 'none';

    }

    private createSpan(parent: HTMLElement): HTMLElement{
        const campo = document.createElement("span");
        campo.className ='campo';
        parent.appendChild(campo);
        return campo
    }

    private createSpanCheck(parent: HTMLElement): HTMLElement{
        const campo = document.createElement("span");
        campo.className = 'campo check';
        parent.appendChild(campo);
        return campo
    }

    private createSpanRange(parent: HTMLElement): HTMLElement{
        const campo = document.createElement("span");
        campo.className ='campo range';
        parent.appendChild(campo);
        return campo
    }

    private createLabel(text: string,parent: HTMLElement): HTMLLabelElement{
        const label = document.createElement("label");
        label.className = 'texto-2';
        label.innerText = text
        parent.appendChild(label);
        return label
    }

    private createInputText(id: string,parent: HTMLElement): HTMLInputElement{
        const input = document.createElement('input');
        input.className = 'texto texto-2';
        input.type = 'text';
        input.id = id;
        parent.appendChild(input);
        const div = document.createElement('div');
        div.className = 'msg-error texto-2';
        div.id = id+'_error_msg';
        parent.appendChild(div);
        return input
    }

    private createInputNumber(id: string,parent: HTMLElement): HTMLInputElement{
        const input = document.createElement('input');
        input.className = 'texto texto-2';
        input.type = 'number';
        input.id = id;
        let label = parent.getElementsByTagName('label');
        input.min = '0';
        parent.appendChild(input);

        // Prohibe escribir numeros negativos
        // @ts-ignore
        input.onkeydown = (e:KeyboardEvent) => {
            if (!((e.keyCode > 95 && e.keyCode < 106)
                || (e.keyCode > 47 && e.keyCode < 58)
                || e.keyCode == 8 || e.keyCode == 188 || e.keyCode == 190 || e.keyCode == 37 || e.keyCode == 39) && (label[0].innerText != 'Latitude (degrees)*' && label[0].innerText != 'Longitude (degrees)*')) {
                return false;
            }
        }
        if (label[0].innerText == 'Resolution (min)'){
            input.onchange =()=>{
                if(+input.value <15){
                    input.value = '15'
                }else if(+input.value >60){
                    input.value = '60'
                }
            }
        }
        const div = document.createElement('div');
        div.className = 'msg-error texto-2';
        div.id = id+'_error_msg';
        parent.appendChild(div);
        return input
    }

    private createInputDate(id: string,parent: HTMLElement): HTMLElement{
        const input = document.createElement('input');
        input.className = 'texto texto-2';
        input.type = 'date'
        input.id = id;
        parent.appendChild(input);
        const div = document.createElement('div');
        div.className = 'msg-error texto-2';
        div.id = id+'_error_msg';
        parent.appendChild(div);
        return input
    }

    private createInputHour(id: string, parent: HTMLElement):HTMLElement{
        const input = document.createElement('input');
        input.className = 'texto texto-2'
        input.type = 'time';
        input.id = id
        input.step = '360';
        input.value = '00:00';
        parent.appendChild(input);
        const div = document.createElement('div');
        div.className = 'msg-error texto-2';
        div.id = id+'_error_msg';
        parent.appendChild(div);
        return input
    }

    private createIframe(parent: HTMLElement, latitude: HTMLInputElement,longitude: HTMLInputElement): HTMLIFrameElement{
        const iframe = document.createElement("iframe");
        iframe.className = "iframe"
        iframe.height = "300px";
        iframe.src = iframe.src = "https://maps.google.com/maps?width=100%25&height=600&hl=en&q=" + latitude.value + "," + longitude.value + "+(Park)&t=&z=14&ie=UTF8&iwloc=B&output=embed"
        iframe.frameBorder = "0";
        iframe.referrerPolicy = "no-referrer-when-downgrade"
        iframe.allowFullscreen = true;
        parent.appendChild(iframe);

        if(latitude!= null) {
            latitude.onchange = () => {
                if (latitude.value != null && longitude.value != null) {
                    iframe.src = "https://maps.google.com/maps?width=100%25&height=600&hl=en&q=" + latitude.value + "," + longitude.value + "+(Park)&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                }
            }
        }
        if(longitude!= null) {
            longitude.onchange = () => {
                if (latitude.value != null && longitude.value != null) {
                    iframe.src = "https://maps.google.com/maps?width=100%25&height=600&hl=en&q=" + latitude.value + "," + longitude.value + "+(Park)&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                }
            }
        }
        return iframe
    }

    private createSelect(id: string,options:string[],parent: HTMLElement): HTMLElement{
        const input = document.createElement('select');
        input.className = 'texto-2';
        input.id = id;
        parent.appendChild(input);
        for(let i = 0;i<options.length;i++){
            let option = document.createElement('option');
            option.innerText = options[i];
            input.appendChild(option);
        }
        const div = document.createElement('div');
        div.className = 'msg-error texto-2';
        div.id = id+'_error_msg';
        parent.appendChild(div);
        return input
    }

    private createButton(id: string,text: string,parent: HTMLElement, visible: boolean): HTMLElement{
        const span = document.createElement('span');
        span.className = 'botonera';
        if(visible){
            span.setAttribute("style", "display: flex;justify-content: center")
        }else {
            span.setAttribute("style", "display: none;justify-content: center")
        }
        parent.appendChild(span);
        const span2 = document.createElement('span');
        span2.className = 'boton ampliado';
        span2.id = id
        span.appendChild(span2);
        const span3 = document.createElement('span');
        span3.className = 'accion texto-3';
        span3.innerText = text;
        span2.appendChild(span3);
        return span2
    }

    private createConfigureButtons(errormsg: HTMLElement, colEdit: HTMLElement, colDelete: HTMLElement, parent:HTMLElement): HTMLElement{
        let firstDelivery = false;
        if(parent.className == 'contenedor'){
            let deliveryAsset = parent.parentElement as HTMLElement;
            if(deliveryAsset.getElementsByClassName("contenedor").length == 1){
                firstDelivery = true;
            }
        }
        let popupEdit = document.createElement("div");
        popupEdit.className = "popup";
            let popupcol = document.createElement("span");
            popupcol.className = "row columnas"

                let editButton = document.createElement("b");
                editButton.style.marginRight = "0px"
                    let editImg = document.createElement("img");
                    editImg.className = "icono"
                    editImg.src = "/img/edit-svgrepo-com.svg"
                editButton.appendChild(editImg);
                let spantext = document.createElement("span");
                spantext.className = "popuptext tooltip-bottom"
                spantext.innerText = "Edit"
                editButton.onmouseenter = () =>{
                    spantext.classList.toggle("show");
                };
                editButton.onmouseleave = () =>{
                    spantext.classList.toggle("show");
                };

                let cancelSave: IFTrialSolar|IFTrialWind|IFTrialDelivery;


                editButton.onclick = () =>{
                    //Bloqeo los botones para continuar hasta que esté editado o cancelado
                    this.setBlockDeliveryButton(this.bb1_wind,this.bb2_wind,this.bb4_wind)
                    this.setBlockDeliveryButton(this.bb1_solar,this.bb2_solar,this.bb4_solar)
                    this.setBlockDeliveryButton(this.bb1,this.bb2,this.bb4)
                    let type = parent.getElementsByClassName('titulo-2');
                    if(parent.className == "contenedor"){
                        cancelSave = this.getFormValuesDelivery(parent);
                    }else if (type[0].innerHTML.slice(0,3) == 'Sol'){
                        cancelSave = this.getFormValuesSolar(parent,[]);
                    }else if (type[0].innerHTML.slice(0,3) == 'Win'){
                        cancelSave = this.getFormValuesWind(parent,[]);
                    }
                    //Bloqueo todos los botnoes de delivery o delete de los demás bloques
                    let configureButtons = document.getElementsByClassName("popup");
                    for(let i =0; i<configureButtons.length;i++){
                        let icons =configureButtons[i].getElementsByTagName("b");
                        if(icons.length > 1){
                            icons[0].style.display = 'none';
                        }
                    }
                //Cambio los botones de editar y eliminar por los de cancelar o aceptar
                    errormsg.innerText = "Editing... (please cancel or confirm before continuing)"
                    editButton.style.display = "none";
                    deleteButton.style.display = "none";
                    acceptButton.style.display = "flex";
                    cancelButton.style.display = "flex"
                    //Bloqueo el úlitmo container que esté editando
                    let lastAsset = document.getElementsByClassName("w3-container");
                    this.disableContainer(lastAsset[lastAsset.length-1] as HTMLElement);

                    //Activo el paquete para que se pueda editar
                    this.enableContainer(parent);

                    //bloquea el botón del ultimo asset
                    let botoneras = lastAsset[lastAsset.length-1].getElementsByClassName("botonera");
                    this.setBlockDeliveryButton(botoneras[0] as HTMLElement,botoneras[1] as HTMLElement,botoneras[2] as HTMLElement);

                    //Activo que puedan añadir deliverys para ese contenedor
                    if(parent.className != 'contenedor'){
                        let buttonBlock = parent.getElementsByClassName("boton block");
                        let button = parent.getElementsByClassName("boton ampliado");
                        this.setNormalDeliveryButton(button[0] as HTMLElement,buttonBlock[0] as HTMLElement);
                    }
                    //BLoquea el delivery o contenedor que está editando
                    let deliverys = lastAsset[lastAsset.length-1].getElementsByClassName("contenedor");
                    if(deliverys.length > 0){
                        this.disableContainer(deliverys[deliverys.length-1] as HTMLElement);
                    }
                }


                //Cuando el contenedor se crea no debe aparecer, solo aparecerá cuando se pulse la opcion de new delivery
                editButton.style.display = "none";
                let acceptButton = document.createElement("b");
                acceptButton.style.display = "none"
                acceptButton.style.marginRight = "0px"
                    let acceptImg = document.createElement("img");
                    acceptImg.className = "icono"
                    acceptImg.src = "/img/check-svgrepo-com.svg";
                acceptButton.appendChild(acceptImg);
                let spantext1_1 = document.createElement("span");
                spantext1_1.className = "popuptext tooltip-bottom";
                spantext1_1.innerText = "Acept";
                acceptButton.onmouseenter = () =>{
                    spantext1_1.classList.toggle("show");
                };
                acceptButton.onmouseleave = () =>{
                    spantext1_1.classList.toggle("show");
                };
                acceptButton.onclick = () =>{
                    if(parent.className == 'contenedor') {
                        this.processCheckDeliveryForm(parent).then(async () => {
                            //vuelvo a bloquear el contenedor
                            this.disableContainer(parent);
                            this.aproveContainer(parent)
                            //Vuelvo a activar el asset o el delivery que corresponda
                            let lastAssets = document.getElementsByClassName("w3-container");
                            let lastAsset = lastAssets[lastAssets.length - 1] as HTMLElement
                            //compruebo si tengo que activar el asset o el delivery
                            let deliverys = lastAsset.getElementsByClassName("contenedor")
                            if (deliverys.length > 0) {
                                this.enableContainer(deliverys[deliverys.length - 1] as HTMLElement)
                            } else {
                                this.enableContainer(lastAsset);
                            }
                            //Vuelvo a activar los botones
                            this.setNormalButton();
                            let buttonBlock = lastAsset.getElementsByClassName("boton block")
                            let button = lastAsset.getElementsByClassName("boton ampliado");
                            this.setNormalDeliveryButton(button[0] as HTMLElement, buttonBlock[0] as HTMLElement);
                            //vuelvo a colocar los botones de edit y delete
                            errormsg.innerText = ''
                            acceptButton.style.display = 'none'
                            cancelButton.style.display = 'none'
                            editButton.style.display = 'flex'
                            deleteButton.style.display = 'flex'
                            //Desbloqueo todos los botnoes de delivery o delete de los demás bloques
                            let configureButtons = document.getElementsByClassName("popup");
                            for(let i =0; i<configureButtons.length;i++){
                                let icons =configureButtons[i].getElementsByTagName("b");
                                if(icons.length > 1 && i<configureButtons.length-2){
                                    icons[0].style.display = 'flex';
                                }else{
                                    //Si es el primer contenedor no tengo que activar el último botón
                                    if (deliverys.length == 1) {
                                        if(i == configureButtons.length-2){
                                            icons[0].style.display = 'flex';
                                        }
                                    }//Si el ultimo contenedor no es el primer delivery desbloqueo el penúltimo (Edit)
                                    else if (i == configureButtons.length-1){
                                        icons[0].style.display = 'flex';
                                    }
                                }
                            }
                        }).catch(async (err) => {
                            console.log("Error sending form", err);
                        });
                    }else {
                        //valido de nuevo
                        this.processCheckYourForm(parent).then(async () => {
                            //vuelvo a bloquear el contenedor
                            this.disableContainer(parent);
                            this.aproveContainer(parent)
                            //Vuelvo a activar el asset o el delivery que corresponda
                            let lastAssets = document.getElementsByClassName("w3-container");
                            let lastAsset = lastAssets[lastAssets.length - 1] as HTMLElement
                            //compruebo si tengo que activar el asset o el delivery
                            let deliverys = lastAsset.getElementsByClassName("contenedor")
                            if (deliverys.length > 0) {
                                this.enableContainer(deliverys[deliverys.length - 1] as HTMLElement)
                            } else {
                                this.enableContainer(lastAsset);
                            }
                            //Vuelvo a activar los botones
                            this.setNormalButton();
                            let buttonBlock = lastAsset.getElementsByClassName("boton block")
                            let button = lastAsset.getElementsByClassName("boton ampliado");
                            this.setNormalDeliveryButton(button[0] as HTMLElement, buttonBlock[0] as HTMLElement);
                            //BLoqueo los botones del delivery del asset que no estamos configurando
                            if (lastAsset.id != parent.id) {
                                let botoneras = parent.getElementsByClassName("botonera");
                                this.setBlockDeliveryButton(botoneras[0] as HTMLElement, botoneras[1] as HTMLElement, botoneras[2] as HTMLElement);
                            }
                            //vuelvo a colocar los botones de edit y delete
                            errormsg.innerText = ''
                            acceptButton.style.display = 'none'
                            cancelButton.style.display = 'none'
                            editButton.style.display = 'flex'
                            deleteButton.style.display = 'flex'
                            //Desbloqueo todos los botnoes de delivery o delete de los demás bloques
                            let configureButtons = document.getElementsByClassName("popup");
                            for(let i =0; i<configureButtons.length;i++){
                                let icons =configureButtons[i].getElementsByTagName("b");
                                if(icons.length > 1 && i<configureButtons.length-2){
                                    icons[0].style.display = 'flex';
                                }else{
                                    //Si es el primer contenedor no tengo que activar el último botón
                                    if (deliverys.length == 1) {
                                        if(i == configureButtons.length-2){
                                            icons[0].style.display = 'flex';
                                        }
                                    }//Si el ultimo contenedor no es el primer delivery desbloqueo el penúltimo (Edit)
                                    else if (i == configureButtons.length-1){
                                        icons[0].style.display = 'flex';
                                    }
                                }
                            }
                        }).catch(async (err) => {
                            console.log("Error sending form", err);
                        });
                    }

                }


        popupEdit.appendChild(popupcol);
        colEdit.appendChild(popupEdit)

        let popupDelete = document.createElement("div");
        popupDelete.className = "popup";
            let popupcol2 = document.createElement("span");
            popupcol2.className = "row columnas"
                let deleteButton = document.createElement("b");
                deleteButton.style.display = "none;"
                deleteButton.style.marginRight = "0px"
                deleteButton.style.marginTop = "9px"
                    let deleteImg = document.createElement("img");
                    deleteImg.className = "icono";
                    deleteImg.src = "/img/delete-settings-svgrepo-com.svg";
                deleteButton.appendChild(deleteImg);
                let spantext2 = document.createElement("span");
                spantext2.className = "popuptext tooltip-bottom"
                spantext2.innerText = "Remove"
                deleteButton.onclick = () => {
                    parent.remove();
                    //Si es un delivery no borramos el separador
                    if(parent.className == 'w3-container') {
                        let separadores = document.getElementsByTagName('hr');
                        if(separadores.length>0){
                            separadores[separadores.length-1].remove();
                        }
                    }
                }
                deleteButton.onmouseenter = () =>{
                    spantext2.classList.toggle("show");
                };
                deleteButton.onmouseleave = () =>{
                    spantext2.classList.toggle("show");
                };

                let cancelButton = document.createElement("b");
                cancelButton.style.display = "none"
                cancelButton.style.marginRight = "0px"
                    let cancelImg = document.createElement("img");
                    cancelImg.className = "icono"
                    cancelImg.src = "/img/delete-svgrepo-com.svg";
                cancelButton.appendChild(cancelImg);
                let spantext2_1 = document.createElement("span");
                spantext2_1.className = "popuptext tooltip-bottom";
                spantext2_1.innerText = "Cancel";
                cancelButton.onmouseenter = () =>{
                    spantext2_1.classList.toggle("show");
                };
                cancelButton.onmouseleave = () =>{
                    spantext2_1.classList.toggle("show");
                };
                cancelButton.onclick = () => {
                    //vuelvo a colocar los botones de edit y delete
                    errormsg.innerText = ''
                    acceptButton.style.display = 'none'
                    cancelButton.style.display = 'none'
                    editButton.style.display = 'flex'
                    deleteButton.style.display = 'flex'

                    //Si habia algún error y cancelamos lo validamos
                    this.aproveContainer(parent);

                    //Bloquea de nuevo el contenedor
                    this.disableContainer(parent);

                    //Vuelvo a activar el ultimo contenedor
                    let lastAssets = document.getElementsByClassName("w3-container");
                    let lastAsset = lastAssets[lastAssets.length-1] as HTMLElement

                    //compruebo si tengo que activar el asset o el delivery
                    let deliverys = lastAsset.getElementsByClassName("contenedor")
                    if (deliverys.length > 0){
                        this.enableContainer(deliverys[deliverys.length-1] as HTMLElement)
                    }else{
                        this.enableContainer(lastAsset);
                    }

                    //BLoqueo los botones del delivery del asset que no estamos configurando
                    if(lastAsset.id != parent.id && parent.className != 'contenedor'){
                        let botoneras = parent.getElementsByClassName("botonera");
                        this.setBlockDeliveryButton(botoneras[0] as HTMLElement,botoneras[1] as HTMLElement,botoneras[2] as HTMLElement);
                    }

                    //Vuelvo a activar los botones del ultimo asset
                    this.setNormalButton();
                    let buttonBlock = lastAsset.getElementsByClassName("boton block")
                    let button = lastAsset.getElementsByClassName("boton ampliado");
                    this.setNormalDeliveryButton(button[0] as HTMLElement,buttonBlock[0] as HTMLElement);

                    //COMPRUEBO SI TENGO QUE RECUPERAR UN ASSET DE SOLAR O DE VIENTO VIENDO SI TIENE AC
                    let inputs = parent.getElementsByTagName("input");
                    let selects = parent.getElementsByTagName("select");
                    if (inputs.length == 20 ) {
                        if("ac" in cancelSave) {
                            inputs[0].value = cancelSave.nameStation;
                            inputs[1].value = cancelSave.location;
                            inputs[2].value = cancelSave.latitude;
                            inputs[3].value = cancelSave.longitude;
                            inputs[4].value = cancelSave.ac;
                            inputs[5].value = cancelSave.dc;
                            selects[0].value = cancelSave.trackingType
                            inputs[6].value = cancelSave.COD;
                            inputs[7].checked = cancelSave.power;
                            inputs[8].checked = cancelSave.temperature;
                            inputs[9].checked = cancelSave.GHI;
                            inputs[10].checked = cancelSave.DNI;
                            inputs[11].checked = cancelSave.DHI;
                            inputs[12].checked = cancelSave.cloud;
                        }
                    }else if(inputs.length == 16){
                        if( "nominal" in cancelSave) {
                            inputs[0].value = cancelSave.nameStation;
                            inputs[1].value = cancelSave.location;
                            inputs[2].value = cancelSave.latitude;
                            inputs[3].value = cancelSave.longitude;
                            inputs[4].value = cancelSave.nominal;
                            inputs[5].checked = cancelSave.power;
                            inputs[6].checked = cancelSave.wind;
                            inputs[7].checked = cancelSave.direction;
                            inputs[8].checked = cancelSave.pression;
                        }
                    }else{
                        if ("delivery_each" in cancelSave) {
                            selects[0].value = cancelSave.delivery_each;
                            inputs[0].value = cancelSave.start_hour;
                            selects[1].value = cancelSave.timeStamp;
                            inputs[1].value = cancelSave.resolution;
                            inputs[2].checked = cancelSave.csv;
                            inputs[3].checked = cancelSave.xls;
                            inputs[4].checked = cancelSave.ftp;
                            inputs[5].checked = cancelSave.api;
                            inputs[6].checked = cancelSave.email;
                       }
                    }
                    //Desbloqueo todos los botnoes de delivery o delete de los demás bloques
                    let configureButtons = document.getElementsByClassName("popup");
                    for(let i =0; i<configureButtons.length;i++){
                        let icons =configureButtons[i].getElementsByTagName("b");
                        if(icons.length > 1 && i<configureButtons.length-2){
                            icons[0].style.display = 'flex';
                        }else{
                            //Si es el primer contenedor no tengo que activar el último botón
                            if (deliverys.length == 1) {
                                if(i == configureButtons.length-2){
                                    icons[0].style.display = 'flex';
                                }
                            }//Si el ultimo contenedor no es el primer delivery desbloqueo el penúltimo (Edit)
                            else if (i == configureButtons.length-1){
                                icons[0].style.display = 'flex';
                            }
                        }
                    }
                }

        if(!firstDelivery){
            popupcol.appendChild(editButton)
            popupcol.appendChild(spantext)
        }
        if(firstDelivery){
            let emptyButton = document.createElement("b");
            acceptButton.style.display = "none"
            acceptButton.style.marginRight = "0px"
            popupcol.appendChild(emptyButton);
            popupcol2.appendChild(editButton)
            popupcol2.appendChild(spantext)
        }else {
            popupcol2.appendChild(deleteButton)
            popupcol2.appendChild(spantext2)
        }
        popupcol.appendChild(acceptButton)
        popupcol.appendChild(spantext1_1);
        popupcol2.appendChild(cancelButton)
        popupcol2.appendChild(spantext2_1);

        popupDelete.appendChild(popupcol2);
        colDelete.appendChild(popupDelete);

    return editButton
    }

    private checkBox (id: string,textContent:string,parent:HTMLElement){
        const inputCheck = this.input0.cloneNode() as HTMLInputElement;
        const svg0 = this.svg0.cloneNode(true);
        const svg1 = this.svg1.cloneNode(true);
        const labelCheck = this.labelCheck.cloneNode() as HTMLLabelElement;;
        labelCheck.textContent = textContent;
        labelCheck.htmlFor = id;
        inputCheck.id = id
        parent.appendChild(inputCheck);
        parent.appendChild(svg0);
        parent.appendChild(svg1);
        parent.appendChild(labelCheck);
        if(textContent == 'Pression' || textContent == 'Cloud coverage'){
            parent.style.display = 'none';
        }
    }

    private newDelivery (countDelivery: number,type: string,parent:HTMLElement,fila: HTMLElement,id_element: string){
        let idAsset ="";
        let assetCount = 0;
        let typeAsset = "";
        if(id_element.substring(0,13) == "deliverySolar"){
            idAsset = id_element.substring(13,id_element.length);
            assetCount = this.solarCount;
            typeAsset = "Solar"
        }if(id_element.substring(0,12) =="deliveryWind"){
            idAsset = id_element.substring(12,id_element.length);
            assetCount = this.windCount;
            typeAsset = "Wind"
        }
        const filaTitulo = document.createElement("span");
        filaTitulo.className ='fila-campos';
        const filaSubTitulo = document.createElement("span");
        filaSubTitulo.className ='row columnas';
        filaTitulo.appendChild(filaSubTitulo);
        const colTitulo = document.createElement("span");
        colTitulo.className ='col4';
        filaSubTitulo.appendChild(colTitulo);
        let hdelivery = document.createElement("h2");
        hdelivery.className ='titulo-2';
        if(idAsset == "0"){
            idAsset = ""
        }
        let deliverys = parent.getElementsByClassName("contenedor");
        if(deliverys.length == 0){
            hdelivery.innerText = type+idAsset+" Delivery";
        }else{
            hdelivery.innerText = type+idAsset+" Delivery "+countDelivery;
        }
        if(deliverys.length >= 1){
            if(deliverys.length ==1){
                let editButton = deliverys[deliverys.length-1].getElementsByTagName('b');
                editButton[2].style.display = 'flex';
            }else{
                let editButton = deliverys[deliverys.length-1].getElementsByTagName('b');
                editButton[0].style.display = 'flex';
            }

        }
        colTitulo.appendChild(hdelivery);
        const colTexto = document.createElement("span");
        colTexto.className ='col5';
        colTexto.setAttribute("style","align-self: center;text-align: right;")
        filaSubTitulo.appendChild(colTexto);
        const editmsg = document.createElement("span")
        editmsg.innerText = '';
        editmsg.className = "mensaje texto-3 color-error";
        colTexto.appendChild(editmsg);

        let colEdit: HTMLElement;
        let colDelete: HTMLElement;

            colEdit = document.createElement("span");
            colEdit.className = 'col1';
            colEdit.setAttribute("style", "align-self: center;text-align: right;")
            filaSubTitulo.appendChild(colEdit);

            colDelete = document.createElement("span");
            colDelete.className = 'col1';
            colDelete.setAttribute("style", "align-self: center;text-align: right;padding-right: 24px;")
            filaSubTitulo.appendChild(colDelete);
            //SI hay mas de uno activamos el edit de ese delivey
        if(deliverys.length>1) {
            let configureColumns = deliverys[deliverys.length - 1].getElementsByTagName('b');
            let editControl = configureColumns[2] as HTMLElement
            editControl.style.display = 'flex';
        }

        let contenedor = document.createElement("span");
        contenedor.className = "contenedor";
        contenedor.setAttribute("style", "background-color: rgb(245, 245, 245);width: 100%;box-shadow: 0 5px 30px 0 rgb(0 73 118), 0 2px 10px 0 rgb(0 0 0 / 12%);");
        parent.appendChild(document.createElement("br"))

        //El primer contenedor no se va a poder eliminar
        // if(deliverys.length == 0){
        //     colDelete.style.display = "none";
        // }else{
        //     //SI hay mas de uno activamos el edit de ese delivey
        //     let configureColumns = deliverys[deliverys.length-1].getElementsByTagName('b') ;
        //     let editControl = configureColumns[0] as HTMLElement
        //     editControl.style.display = 'flex';
        // }

        const fila5 = document.createElement("span");
        fila5.className ='fila-campos';
            let campo15 = this.createSpan(fila5);
            this.createLabel('Deliveries each:',campo15);
            this.createSelect('selectDelivery'+assetCount+" Delivery "+countDelivery,['--Select frequency--','1 Hour','2 Hours','3 Hours','4 Hours','6 Hours','12 Hours','24 Hours'],campo15);

            let campo32 = this.createSpan(fila5);
            this.createLabel('Start Hour',campo32);
            this.createInputHour('hourDelivery'+assetCount+" Delivery "+countDelivery,campo32);

            let campo16 = this.createSpan(fila5);
            this.createLabel('TimeStamp',campo16);
            this.createSelect('timestampSolar'+assetCount+" Delivery "+countDelivery,['--Select timestamp--'].concat(moment.tz.names()),campo16)

            const campo17 =this.createSpan(fila5);
            this.createLabel('Resolution (min)',campo17);
            this.createInputNumber('resolutionSolar'+assetCount+" Delivery "+countDelivery,campo17)

        const fila10 = document.createElement("span");
        fila10.className ='row columnas';

            const colLabelFormat = document.createElement("span");
            colLabelFormat.className = "col6 cuerpo-texto"
                this.createLabel('Formats (After selection you can request a custom format by sending us an e-mail)',colLabelFormat);
        fila10.appendChild(colLabelFormat);

            const colEspacioLabel = document.createElement("span");
            colEspacioLabel.className = "col1 cuerpo-texto"
        fila10.appendChild(colEspacioLabel);

            const colLabelDelivery = document.createElement("span");
            colLabelDelivery.className = "col6 cuerpo-texto"
                this.createLabel('Delivery',colLabelDelivery);
        fila10.appendChild(colLabelDelivery);


        const fila6 = document.createElement("span");
        fila6.className ='row columnas';
            const colCSV = document.createElement("span");
            colCSV.className = "col1 cuerpo-texto"
                let campo18 = this.createSpanCheck(colCSV);
                    this.checkBox('csv'+typeAsset+assetCount+" Delivery "+countDelivery,'CSV',campo18);
        fila6.appendChild(colCSV);

            const colXLS = document.createElement("span");
            colXLS.className = "col1 cuerpo-texto"
                let campo38 = this.createSpanCheck(colXLS);
                    this.checkBox('xls'+typeAsset+assetCount+" Delivery "+countDelivery,'XLS',campo38);

        fila6.appendChild(colXLS);

            const colEspacio= document.createElement("span");
            colEspacio.className = "col5 cuerpo-texto"
        fila6.appendChild(colEspacio);

            const colFTP= document.createElement("span");
            colFTP.className = "col1 cuerpo-texto"
                let campo21 = this.createSpanCheck(colFTP);
                    this.checkBox('ftp'+typeAsset+assetCount+" Delivery "+countDelivery,'FTP',campo21);
        fila6.appendChild(colFTP);

            const colAPI= document.createElement("span");
            colAPI.className = "col1 cuerpo-texto"
                let campo22 = this.createSpanCheck(colAPI);
                    this.checkBox('api'+typeAsset+assetCount+" Delivery "+countDelivery,'API',campo22);
        fila6.appendChild(colAPI);

            const colMail= document.createElement("span");
            colMail.className = "col1 cuerpo-texto"
                let campo31 = this.createSpanCheck(colMail);
                    this.checkBox('email'+typeAsset+assetCount+" Delivery "+countDelivery,'Email',campo31);
        fila6.appendChild(colMail);

        const fila9 = document.createElement("span");
        fila9.className ='fila-campos';


        //delivery
        parent.insertBefore(contenedor,fila);
        let editButton = this.createConfigureButtons(editmsg,colEdit,colDelete,contenedor);
        parent.insertBefore(document.createElement("br"),fila)
        contenedor.appendChild(document.createElement("br"))
        contenedor.appendChild(filaTitulo);
        contenedor.appendChild(document.createElement("br"))
        contenedor.appendChild(fila5);
        contenedor.appendChild(document.createElement("br"))
        contenedor.appendChild(fila10);
        contenedor.appendChild(document.createElement("br"))
        contenedor.appendChild(fila6);
        contenedor.appendChild(document.createElement("br"))
        contenedor.appendChild(fila9);
        contenedor.appendChild(document.createElement("br"));
    }

    private newSolarForm():void{
        const hr = document.createElement("hr");
        hr.className ='separadorBlog';
        const div = document.createElement("div");
        div.className = "w3-container"
        ///box-shadow: 0 2px 5px 0 rgb(238 153 161), 0 2px 10px 0 rgb(0 0 0 / 12%);
        div.id = "AssetForm"+(this.solarCount + this.windCount).toString();
        const div1 = document.createElement("div");
        div1.className ="w3-panel w3-card"
        div1.setAttribute("style","box-shadow: 0 5px 30px 0 rgb(0 73 118), 0 2px 10px 0 rgb(0 0 0 / 12%);padding-top: 16px;padding-bottom: 16px;");
        this.contenedor.insertBefore(hr,this.botones);
        const filaTitulo = document.createElement("span");
        filaTitulo.className ='fila-campos';
            const filaSubTitulo = document.createElement("span");
            filaSubTitulo.className ='row columnas';
        filaTitulo.appendChild(filaSubTitulo);
                const colTitulo = document.createElement("span");
                colTitulo.className ='col4';
            filaSubTitulo.appendChild(colTitulo);
                    const h2 = document.createElement("h2");
                    h2.className ='titulo-2';
                    if(this.solarCount == 0){
                        h2.innerText = 'Solar asset';
                    }else{
                        h2.innerText = 'Solar asset '+ this.solarCount;
                    }
                colTitulo.appendChild(h2);
                const colTexto = document.createElement("span");
                colTexto.className ='col5';
                colTexto.setAttribute("style","align-self: center;text-align: right;")
            filaSubTitulo.appendChild(colTexto);
                    const editmsg = document.createElement("span")
                    editmsg.innerText = '';
                    editmsg.className = "mensaje texto-3 color-error";
                colTexto.appendChild(editmsg);
                const colEdit = document.createElement("span");
                colEdit.className ='col1';
                colEdit.setAttribute("style","align-self: center;text-align: right;")
            filaSubTitulo.appendChild(colEdit);
                const colDelete = document.createElement("span");
                colDelete.className ='col1';
                colDelete.setAttribute("style","align-self: center;text-align: right;")
            filaSubTitulo.appendChild(colDelete);

        let editButton = this.createConfigureButtons(editmsg,colEdit,colDelete,div);

        const fila0 = document.createElement("span");
        fila0.className ='fila-campos';
            let campo = this.createSpan(fila0);
            this.createLabel('Name of the power station *',campo)
            this.createInputText('nameSolar'+this.solarCount,campo);

        const fila1 = document.createElement("span");
        fila1.className ='fila-campos';
            let campo2 = this.createSpan(fila1);
                this.createLabel('Location',campo2);
                this.createInputText('locationSolar'+this.solarCount,campo2);

            let campo3 = this.createSpan(fila1);
                this.createLabel('Latitude (degrees)*',campo3);
                let latitude = this.createInputNumber('latitudeSolar'+this.solarCount,campo3)

            let campo4 = this.createSpan(fila1);
                this.createLabel('Longitude (degrees)*',campo4);
                let longitude = this.createInputNumber('longitudeSolar'+this.solarCount,campo4);

        const fila7 = document.createElement("span");
        fila7.className ='fila-campos';
        fila7.style.height = "300px";
            this.createIframe(fila7,latitude,longitude);

        const fila2 = document.createElement("span");
        fila2.className ='fila-campos';
            let campo5 = this.createSpanRange(fila2);
                this.createLabel('AC Capacity (inverters) in MW *',campo5);
                this.createInputNumber('acSolar'+this.solarCount,campo5);

            const campo6 = this.createSpanRange(fila2);
                this.createLabel('DC Capacity (modules) in MW *',campo6);
                this.createInputNumber('dcSolar'+this.solarCount,campo6);

        const fila3 = document.createElement("span");
        fila3.className ='fila-campos';
            let campo7 = this.createSpan(fila3);
                this.createLabel('Tracking type',campo7);
                this.createSelect('trackingSolar' + this.solarCount,['--Select type--','Fixed','Horizontal single axis'],campo7)

            let campo8 = this.createSpan(fila3);
                this.createLabel('COD',campo8);
                this.createInputDate('codSolar'+this.solarCount,campo8);


        let label9 = document.createElement("label");
        label9.className = 'texto-2';
        label9.innerText = 'Available variables *'

        const fila4 = document.createElement("span");
        fila4.className ='fila-campos';
            let campo9 = this.createSpanCheck(fila4);
                this.checkBox('powerSolar'+this.solarCount,'Power production',campo9);

            const campo10 = this.createSpanCheck(fila4);
                this.checkBox('temperatureSolar'+this.solarCount,'Temperature',campo10);

            let campo11 = this.createSpanCheck(fila4);
                this.checkBox('ghiSolar'+this.solarCount,'GHI',campo11);

            let campo12 = this.createSpanCheck(fila4);
                this.checkBox('dniSolar'+this.solarCount,'DNI',campo12);

            let campo13 = this.createSpanCheck(fila4);
                this.checkBox('dhiSolar'+this.solarCount,'DHI',campo13);

            let campo14 = this.createSpanCheck(fila4);
                this.checkBox('cloudSolar'+this.solarCount,'Cloud coverage',campo14);

        const fila8 = document.createElement("span");
        fila8.className ='fila-campos';
            let solarDeliveryButton = this.createButton('deliverySolar'+this.solarCount,'Add new delivery',fila8,true);
            let solarDeliveryButtonError = this.createButton('deliverySolarError'+this.solarCount,'Add new delivery',fila8,false);
            solarDeliveryButtonError.className = 'boton error'
            let solarDeliveryButtonBlock = this.createButton('deliverySolarError'+this.solarCount,'Add new delivery',fila8,false);
            solarDeliveryButtonBlock.className = 'boton block'
        let deliveryCount = 0

        solarDeliveryButton.onclick = solarDeliveryButtonError.onclick = () =>{
            let botonera = solarDeliveryButton.parentElement as HTMLElement;
            let fila = botonera.parentElement as HTMLElement;
            let chart = fila.parentElement as HTMLElement;
            let assetForm = chart.parentElement as HTMLElement;
            let deliverys = div1.getElementsByClassName("contenedor");
            if(deliverys.length == 0){
                //Si es la primera iteración revisamos los datos del parque
                this.processCheckAssetForm().then(async () => {
                    const hrDelivery = document.createElement("hr");
                    hrDelivery.className ='separadorBlog';
                    editButton.style.display = "flex"
                    chart.insertBefore(hrDelivery,fila8);
                    this.setNormalDeliveryButton(solarDeliveryButton,solarDeliveryButtonError);
                    this.aproveContainer(assetForm);
                    this.disableContainer(assetForm);
                    this.newDelivery(deliveryCount, "Solar asset ", div1, fila8, solarDeliveryButton.id);
                    deliveryCount += 1;
                }).catch(async (err) => {
                    this.setErrorButton_Add_Delivery(solarDeliveryButton,solarDeliveryButtonError);
                    console.log("Error sending form", err);
                });
            //Si ya existe un delivery lo que tenemos que mirar es el delivery anterior
            }else {
                let containers = assetForm.getElementsByClassName('contenedor')
                this.processCheckDeliveryForm(containers[containers.length-1] as HTMLElement).then(async () => {
                    this.aproveContainer(containers[containers.length-1] as HTMLElement);
                    this.disableContainer(containers[containers.length-1] as HTMLElement);
                    this.newDelivery(containers.length, "Solar asset ", div1, fila8, solarDeliveryButton.id);
                }).catch(async (err) => {
                    this.setErrorButton_Add_Delivery(solarDeliveryButton,solarDeliveryButtonError);
                    console.log("Error sending form", err);
                });
            }
        }

        this.contenedor.insertBefore(div,this.botones);
        div.appendChild(div1);
        div1.appendChild(filaTitulo);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila0);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila1);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila7);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila2);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila3);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(label9);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila4);
        //delivery
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila8);
        div1.appendChild(document.createElement("br"));
        this.solarCount +=1;
    }

    private newWindForm():void{
        const hr = document.createElement("hr");
        hr.className ='separadorBlog';
        const div = document.createElement("div");
        div.className = "w3-container"
        ///box-shadow: 0 2px 5px 0 rgb(238 153 161), 0 2px 10px 0 rgb(0 0 0 / 12%);
        div.id = "AssetForm"+(this.solarCount + this.windCount).toString();
        const div1 = document.createElement("div");
        div1.className ="w3-panel w3-card"
        div1.setAttribute("style","box-shadow: 0 5px 30px 0 rgb(0 73 118), 0 2px 10px 0 rgb(0 0 0 / 12%);padding-top: 16px;padding-bottom: 16px;");
        this.contenedor.insertBefore(hr,this.botones);
        const filaTitulo = document.createElement("span");
        filaTitulo.className ='fila-campos';
        const filaSubTitulo = document.createElement("span");
        filaSubTitulo.className ='row columnas';
        filaTitulo.appendChild(filaSubTitulo);
        const colTitulo = document.createElement("span");
        colTitulo.className ='col4';
        filaSubTitulo.appendChild(colTitulo);
        const h2 = document.createElement("h2");
        h2.className ='titulo-2';
        if(this.solarCount == 0){
            h2.innerText = 'Wind asset';
        }else{
            h2.innerText = 'Wind asset '+ this.windCount;
        }
        colTitulo.appendChild(h2);
        const colTexto = document.createElement("span");
        colTexto.className ='col5';
        colTexto.setAttribute("style","align-self: center;text-align: right;")
        filaSubTitulo.appendChild(colTexto);
        const editmsg = document.createElement("span")
        editmsg.innerText = '';
        editmsg.className = "mensaje texto-3 color-error";
        colTexto.appendChild(editmsg);
        const colEdit = document.createElement("span");
        colEdit.className ='col1';
        colEdit.setAttribute("style","align-self: center;text-align: right;")
        filaSubTitulo.appendChild(colEdit);
        const colDelete = document.createElement("span");
        colDelete.className ='col1';
        colDelete.setAttribute("style","align-self: center;text-align: right;")
        filaSubTitulo.appendChild(colDelete);

        let editButton = this.createConfigureButtons(editmsg,colEdit,colDelete,div);

        const fila0 = document.createElement("span");
        fila0.className ='fila-campos';
        const campo = document.createElement("span");
        campo.className ='campo';
        this.createLabel('Name of the power station *',campo);
        this.createInputText('nameWind'+this.windCount,campo);
        fila0.appendChild(campo);

        const fila1 = document.createElement("span");
        fila1.className ='fila-campos';
            const campo2 = this.createSpan(fila1);
                this.createLabel('Location',campo2);
                this.createInputText('locationWind'+this.windCount,campo2);

            const campo3 = this.createSpan(fila1);
                this.createLabel('Latitude (degrees)*',campo3);
                let latitude = this.createInputNumber('latitudeWind'+this.solarCount,campo3);

            const campo4 = this.createSpan(fila1);
                this.createLabel('Longitude (degrees)*',campo4);
                let longitude = this.createInputNumber('longitudeWind'+this.solarCount,campo4);

        const fila7 = document.createElement("span");
        fila7.className ='fila-campos';
            this.createIframe(fila7,latitude,longitude);

        const fila2 = document.createElement("span");
        fila2.className ='fila-campos';
            let campo5 = this.createSpanRange(fila2);
                this.createLabel('Nominal power in MW *',campo5);
                this.createInputNumber('nominalWind'+this.windCount,campo5);

        const label9 = document.createElement("label");
        label9.className = 'texto-2';
        label9.innerText = 'Available variables *'

        const fila4 = document.createElement("span");
        fila4.className ='fila-campos';
            let campo9 = this.createSpanCheck(fila4);
                this.checkBox('power'+this.windCount,'Power',campo9);

            let campo10 = this.createSpanCheck(fila4);
                this.checkBox('wind'+this.windCount,'Wind speed',campo10);

            let campo11 = this.createSpanCheck(fila4);
                this.checkBox('direction'+this.windCount,'Direction',campo11);

            let campo12 = this.createSpanCheck(fila4);
                this.checkBox('pression'+this.windCount,'Pression',campo12);


        const fila8 = document.createElement("span");
        fila8.className ='fila-campos';
        let windDeliveryButton = this.createButton('deliveryWind'+this.windCount,'Add new delivery',fila8,true);
        let windDeliveryButtonError = this.createButton('deliveryWindError'+this.windCount,'Add new delivery',fila8,false);
        windDeliveryButtonError.className = 'boton error'
        let windDeliveryButtonBlock = this.createButton('deliverySolarError'+this.solarCount,'Add new delivery',fila8,false);
        windDeliveryButtonBlock.className = 'boton block'
        let deliveryCount = 0

        windDeliveryButton.onclick = windDeliveryButtonError.onclick = () =>{
            editButton.style.display = "flex"
            let botonera = windDeliveryButton.parentElement as HTMLElement;
            let fila = botonera.parentElement as HTMLElement;
            let chart = fila.parentElement as HTMLElement;
            let assetForm = chart.parentElement as HTMLElement;
            let deliverys = div1.getElementsByClassName("contenedor");
            if(deliverys.length == 0){
                //Si es la primera iteración revisamos los datos del parque
                this.processCheckAssetForm().then(async () => {
                    const hrDelivery = document.createElement("hr");
                    hrDelivery.className ='separadorBlog';
                    chart.insertBefore(hrDelivery,fila8);
                    this.setNormalDeliveryButton(windDeliveryButton,windDeliveryButtonError);
                    this.aproveContainer(assetForm);
                    this.disableContainer(assetForm);
                    this.newDelivery(deliveryCount,"Wind asset ",div1,fila8,windDeliveryButton.id);
                    deliveryCount += 1;
                }).catch(async (err) => {
                    this.setErrorButton_Add_Delivery(windDeliveryButton,windDeliveryButtonError);
                    console.log("Error sending form", err);
                });
            //Si ya existe un delivery lo que tenemos que mirar es el delivery anterior
            }else {
                let containers = assetForm.getElementsByClassName('contenedor')
                this.processCheckDeliveryForm(containers[containers.length-1] as HTMLElement).then(async () => {
                    this.aproveContainer(containers[containers.length-1] as HTMLElement);
                    this.disableContainer(containers[containers.length-1] as HTMLElement);
                    this.newDelivery(deliveryCount,"Wind asset ",div1,fila8,windDeliveryButton.id);
                    deliveryCount += 1;
                }).catch(async (err) => {
                    this.setErrorButton_Add_Delivery(windDeliveryButton,windDeliveryButtonError);
                    console.log("Error sending form", err);
                });
            }
        }

        this.contenedor.insertBefore(div,this.botones);
        div.appendChild(div1);
        div1.appendChild(filaTitulo);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila0);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila1);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila7);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila2);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(label9);
        div1.appendChild(document.createElement("br"));
        div1.appendChild(fila4);
        div1.appendChild(document.createElement("br"));
        //delivery
        div1.appendChild(fila8);
        div1.appendChild(document.createElement("br"));
        this.windCount += 1;
    }

    private disableContainer(parent: HTMLElement): void{
        let inputs = parent.getElementsByTagName('input');
        for (let i = 0; i< inputs.length; i++){
            inputs[i].setAttribute('disabled','true');
        }
        let selects = parent.getElementsByTagName('select');
        for (let i = 0; i< selects.length; i++){
            selects[i].setAttribute('disabled','true');
        }
        if(parent.className == "contenedor"){
            parent.style.boxShadow = ""
        }else{
            // @ts-ignore
            parent.children[0].removeAttribute("style");
            // @ts-ignore
            parent.children[0].setAttribute("style","box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);padding-top: 16px;padding-bottom: 16px;");
        }
    }

    private enableContainer(parent: HTMLElement): void{
        let inputs = parent.getElementsByTagName('input');
        for (let i = 0; i< inputs.length; i++){
            inputs[i].removeAttribute('disabled');
        }
        let selects = parent.getElementsByTagName('select');
        for (let i = 0; i< selects.length; i++){
            selects[i].removeAttribute('disabled');
        }
        if(parent.className == "contenedor"){
            parent.setAttribute("style", "background-color: rgb(245, 245, 245);width: 100%;box-shadow: 0 5px 30px 0 rgb(0 73 118), 0 2px 10px 0 rgb(0 0 0 / 12%);");
        }else{
                // @ts-ignore
                parent.children[0].setAttribute("style","box-shadow: 0 5px 30px 0 rgb(0 73 118), 0 2px 10px 0 rgb(0 0 0 / 12%);padding-top: 16px;padding-bottom: 16px;");
        }
    }

    private aproveContainer(parent: HTMLElement): void{
        let inputs = parent.getElementsByTagName('input');
        for (let i = 0; i< inputs.length; i++){
            if(inputs[i].type == 'file'){
                inputs[i].className = 'texto-2';
            }else{
                inputs[i].className = 'texto texto-2';
            }
        }
        let selects = parent.getElementsByTagName('select');
        for (let i = 0; i< selects.length; i++){
            selects[i].className = 'texto-2';
        }
        let errors_msg = parent.getElementsByClassName('msg-error texto-2');
        for (let i = 0; i< errors_msg.length; i++){
            errors_msg[i].innerHTML = '';
        }
    }

    private contactFailed(): void{
        const form = this.getFormValuesMain();
        if (form.email.length == 0) {
            this.email.className = 'texto texto-2 error';
            this.email_error_msg.innerText = "This field is required";
        } else if (!emailRegex.test(form.email)) {
            this.email.className = 'texto texto-2 error';
            this.email_error_msg.innerText = "Please introduce a valid email";
        } else {
            this.email.className = 'texto texto-2';
            this.email_error_msg.innerText = "";
        }

        if (form.name.length == 0) {
            this.name.className = 'texto texto-2 error';
            this.name_error_msg.innerText = "This field is required";
        }else {
            this.name.className = 'texto texto-2';
            this.name_error_msg.innerText = "";
        }
        if(form.phone.length == 0){
            this.phone.className = 'texto texto-2 error'
            let errorMsg = document.getElementById("error-msg") as HTMLElement;
            errorMsg.innerHTML = 'This field is required';
            errorMsg.style.color = '#d0021b'
        }

        if (form.surename.length == 0) {
            this.surename.className = 'texto texto-2 error';
            this.surename_error_msg.innerText = "This field is required";
        }else {
            this.surename.className = 'texto texto-2';
            this.surename_error_msg.innerText = "";
        }

        if (form.company.length == 0) {
            this.company.className = 'texto texto-2 error';
            this.company_error_msg.innerText = "This field is required";
        }else {
            this.company.className = 'texto texto-2';
            this.company_error_msg.innerText = "";
        }

        //Solo podremos validar el telefono si conocemos el pais de contacto para tener su formato
        if (this.country.value == "--Select Country--"){
            this.country.className = 'texto texto-2 error';
            this.country_error_msg.innerText = "This field is required"
        }else {
            this.country.className = 'texto texto-2';
            this.country_error_msg.innerText = "";
        }

        if (!this.accept.checked) {
            this.accept.className = 'error';
            this.accept_msg.innerHTML = 'I have read and accept the <a href="/legal-notice/" target="_blank" title="Privacy policy">legal terms & conditions</a> (This field is required)';
        } else {
            this.accept.className = 'texto-2';
            this.accept_msg.innerHTML = 'I have read and accept the <a href="/legal-notice/" target="_blank" title="Privacy policy">legal terms & conditions</a> (This field is required)';;
            //<a href="/legal-notice/" title="Privacy policy">legal terms & conditions</a>
            //<div onclick="openInNewTab('www.test.com');">Something To Click On</div>

        }
    }


    private isoConversor(code:string, type:string): string {
        let iso ={
        'AF' : 'Afghanistan',
        'AX' : 'Aland Islands',
        'AL' : 'Albania',
        'DZ' : 'Algeria',
        'AS' : 'American Samoa',
        'AD' : 'Andorra',
        'AO' : 'Angola',
        'AI' : 'Anguilla',
        'AQ' : 'Antarctica',
        'AG' : 'Antigua And Barbuda',
        'AR' : 'Argentina',
        'AM' : 'Armenia',
        'AW' : 'Aruba',
        'AU' : 'Australia',
        'AT' : 'Austria',
        'AZ' : 'Azerbaijan',
        'BS' : 'Bahamas',
        'BH' : 'Bahrain',
        'BD' : 'Bangladesh',
        'BB' : 'Barbados',
        'BY' : 'Belarus',
        'BE' : 'Belgium',
        'BZ' : 'Belize',
        'BJ' : 'Benin',
        'BM' : 'Bermuda',
        'BT' : 'Bhutan',
        'BO' : 'Bolivia',
        'BA' : 'Bosnia And Herzegovina',
        'BW' : 'Botswana',
        'BV' : 'Bouvet Island',
        'BR' : 'Brazil',
        'IO' : 'British Indian Ocean Territory',
        'BN' : 'Brunei Darussalam',
        'BG' : 'Bulgaria',
        'BF' : 'Burkina Faso',
        'BI' : 'Burundi',
        'KH' : 'Cambodia',
        'CM' : 'Cameroon',
        'CA' : 'Canada',
        'CV' : 'Cape Verde',
        'KY' : 'Cayman Islands',
        'CF' : 'Central African Republic',
        'TD' : 'Chad',
        'CL' : 'Chile',
        'CN' : 'China',
        'CX' : 'Christmas Island',
        'CC' : 'Cocos (Keeling) Islands',
        'CO' : 'Colombia',
        'KM' : 'Comoros',
        'CG' : 'Congo',
        'CD' : 'Congo, Democratic Republic',
        'CK' : 'Cook Islands',
        'CR' : 'Costa Rica',
        'CI' : 'Cote D\'Ivoire',
        'HR' : 'Croatia',
        'CU' : 'Cuba',
        'CY' : 'Cyprus',
        'CZ' : 'Czech Republic',
        'DK' : 'Denmark',
        'DJ' : 'Djibouti',
        'DM' : 'Dominica',
        'DO' : 'Dominican Republic',
        'EC' : 'Ecuador',
        'EG' : 'Egypt',
        'SV' : 'El Salvador',
        'GQ' : 'Equatorial Guinea',
        'ER' : 'Eritrea',
        'EE' : 'Estonia',
        'ET' : 'Ethiopia',
        'FK' : 'Falkland Islands (Malvinas)',
        'FO' : 'Faroe Islands',
        'FJ' : 'Fiji',
        'FI' : 'Finland',
        'FR' : 'France',
        'GF' : 'French Guiana',
        'PF' : 'French Polynesia',
        'TF' : 'French Southern Territories',
        'GA' : 'Gabon',
        'GM' : 'Gambia',
        'GE' : 'Georgia',
        'DE' : 'Germany',
        'GH' : 'Ghana',
        'GI' : 'Gibraltar',
        'GR' : 'Greece',
        'GL' : 'Greenland',
        'GD' : 'Grenada',
        'GP' : 'Guadeloupe',
        'GU' : 'Guam',
        'GT' : 'Guatemala',
        'GG' : 'Guernsey',
        'GN' : 'Guinea',
        'GW' : 'Guinea-Bissau',
        'GY' : 'Guyana',
        'HT' : 'Haiti',
        'HM' : 'Heard Island & Mcdonald Islands',
        'VA' : 'Holy See (Vatican City State)',
        'HN' : 'Honduras',
        'HK' : 'Hong Kong',
        'HU' : 'Hungary',
        'IS' : 'Iceland',
        'IN' : 'India',
        'ID' : 'Indonesia',
        'IR' : 'Iran, Islamic Republic Of',
        'IQ' : 'Iraq',
        'IE' : 'Ireland',
        'IM' : 'Isle Of Man',
        'IL' : 'Israel',
        'IT' : 'Italy',
        'JM' : 'Jamaica',
        'JP' : 'Japan',
        'JE' : 'Jersey',
        'JO' : 'Jordan',
        'KZ' : 'Kazakhstan',
        'KE' : 'Kenya',
        'KI' : 'Kiribati',
        'KR' : 'Korea',
        'KW' : 'Kuwait',
        'KG' : 'Kyrgyzstan',
        'LA' : 'Lao People\'s Democratic Republic',
        'LV' : 'Latvia',
        'LB' : 'Lebanon',
        'LS' : 'Lesotho',
        'LR' : 'Liberia',
        'LY' : 'Libyan Arab Jamahiriya',
        'LI' : 'Liechtenstein',
        'LT' : 'Lithuania',
        'LU' : 'Luxembourg',
        'MO' : 'Macao',
        'MK' : 'Macedonia',
        'MG' : 'Madagascar',
        'MW' : 'Malawi',
        'MY' : 'Malaysia',
        'MV' : 'Maldives',
        'ML' : 'Mali',
        'MT' : 'Malta',
        'MH' : 'Marshall Islands',
        'MQ' : 'Martinique',
        'MR' : 'Mauritania',
        'MU' : 'Mauritius',
        'YT' : 'Mayotte',
        'MX' : 'Mexico',
        'FM' : 'Micronesia, Federated States Of',
        'MD' : 'Moldova',
        'MC' : 'Monaco',
        'MN' : 'Mongolia',
        'ME' : 'Montenegro',
        'MS' : 'Montserrat',
        'MA' : 'Morocco',
        'MZ' : 'Mozambique',
        'MM' : 'Myanmar',
        'NA' : 'Namibia',
        'NR' : 'Nauru',
        'NP' : 'Nepal',
        'NL' : 'Netherlands',
        'AN' : 'Netherlands Antilles',
        'NC' : 'New Caledonia',
        'NZ' : 'New Zealand',
        'NI' : 'Nicaragua',
        'NE' : 'Niger',
        'NG' : 'Nigeria',
        'NU' : 'Niue',
        'NF' : 'Norfolk Island',
        'MP' : 'Northern Mariana Islands',
        'NO' : 'Norway',
        'OM' : 'Oman',
        'PK' : 'Pakistan',
        'PW' : 'Palau',
        'PS' : 'Palestinian Territory, Occupied',
        'PA' : 'Panama',
        'PG' : 'Papua New Guinea',
        'PY' : 'Paraguay',
        'PE' : 'Peru',
        'PH' : 'Philippines',
        'PN' : 'Pitcairn',
        'PL' : 'Poland',
        'PT' : 'Portugal',
        'PR' : 'Puerto Rico',
        'QA' : 'Qatar',
        'RE' : 'Reunion',
        'RO' : 'Romania',
        'RU' : 'Russian Federation',
        'RW' : 'Rwanda',
        'BL' : 'Saint Barthelemy',
        'SH' : 'Saint Helena',
        'KN' : 'Saint Kitts And Nevis',
        'LC' : 'Saint Lucia',
        'MF' : 'Saint Martin',
        'PM' : 'Saint Pierre And Miquelon',
        'VC' : 'Saint Vincent And Grenadines',
        'WS' : 'Samoa',
        'SM' : 'San Marino',
        'ST' : 'Sao Tome And Principe',
        'SA' : 'Saudi Arabia',
        'SN' : 'Senegal',
        'RS' : 'Serbia',
        'SC' : 'Seychelles',
        'SL' : 'Sierra Leone',
        'SG' : 'Singapore',
        'SK' : 'Slovakia',
        'SI' : 'Slovenia',
        'SB' : 'Solomon Islands',
        'SO' : 'Somalia',
        'ZA' : 'South Africa',
        'GS' : 'South Georgia And Sandwich Isl.',
        'ES' : 'Spain',
        'LK' : 'Sri Lanka',
        'SD' : 'Sudan',
        'SR' : 'Suriname',
        'SJ' : 'Svalbard And Jan Mayen',
        'SZ' : 'Swaziland',
        'SE' : 'Sweden',
        'CH' : 'Switzerland',
        'SY' : 'Syrian Arab Republic',
        'TW' : 'Taiwan',
        'TJ' : 'Tajikistan',
        'TZ' : 'Tanzania',
        'TH' : 'Thailand',
        'TL' : 'Timor-Leste',
        'TG' : 'Togo',
        'TK' : 'Tokelau',
        'TO' : 'Tonga',
        'TT' : 'Trinidad And Tobago',
        'TN' : 'Tunisia',
        'TR' : 'Turkey',
        'TM' : 'Turkmenistan',
        'TC' : 'Turks And Caicos Islands',
        'TV' : 'Tuvalu',
        'UG' : 'Uganda',
        'UA' : 'Ukraine',
        'AE' : 'United Arab Emirates',
        'GB' : 'United Kingdom',
        'US' : 'United States',
        'UM' : 'United States Outlying Islands',
        'UY' : 'Uruguay',
        'UZ' : 'Uzbekistan',
        'VU' : 'Vanuatu',
        'VE' : 'Venezuela',
        'VN' : 'Viet Nam',
        'VG' : 'Virgin Islands, British',
        'VI' : 'Virgin Islands, U.S.',
        'WF' : 'Wallis And Futuna',
        'EH' : 'Western Sahara',
        'YE' : 'Yemen',
        'ZM' : 'Zambia',
        'ZW' : 'Zimbabwe'}
        let country ={
            'Afghanistan':	'AF',
            'Aland Islands':'AX',
            'Albania':'AL',
            'Algeria':'DZ',
            'American Samoa':'AS',
            'Andorra':'AD',
            'Angola':'AO',
            'Anguilla':'AI',
            'Antarctica':'AQ',
            'Antigua And Barbuda':'AG',
            'Argentina':'AR',
            'Armenia':'AM',
            'Aruba':'AW',
            'Australia':'AU',
            'Austria':'AT',
            'Azerbaijan':'AZ',
            'Bahamas':'BS',
            'Bahrain':'BH',
            'Bangladesh':'BD',
            'Barbados':'BB',
            'Belarus':'BY',
            'Belgium':'BE',
            'Belize':'BZ',
            'Benin':'BJ',
            'Bermuda':'BM',
            'Bhutan':'BT',
            'Bolivia':'BO',
            'Bosnia And Herzegovina':'BA',
            'Botswana':'BW',
            'Bouvet Island':'BV',
            'Brazil':'BR',
            'British Indian Ocean Territory':'IO',
            'Brunei Darussalam':'BN',
            'Bulgaria':'BG',
            'Burkina Faso':'BF',
            'Burundi':'BI',
            'Cambodia':'KH',
            'Cameroon':'CM',
            'Canada':'CA',
            'Cape Verde':'CV',
            'Cayman Islands':'KY',
            'Central African Republic':'CF',
            'Chad':'TD',
            'Chile':'CL',
            'China':'CN',
            'Christmas Island':'CX',
            'Cocos (Keeling) Islands':'CC',
            'Colombia':'CO',
            'Comoros':'KM',
            'Congo':'CG',
            'Congo: Democratic Republic':'CD',
            'Cook Islands':'CK',
            'Costa Rica':'CR',
            'Cote D\'Ivoire':'CI',
            'Croatia':'HR',
            'Cuba':'CU',
            'Cyprus':'CY',
            'Czech Republic':'CZ',
            'Denmark':'DK',
            'Djibouti':'DJ',
            'Dominica':'DM',
            'Dominican Republic':'DO',
            'Ecuador':'EC',
            'Egypt':'EG',
            'El Salvador':'SV',
            'Equatorial Guinea':'GQ',
            'Eritrea':'ER',
            'Estonia':'EE',
            'Ethiopia':'ET',
            'Falkland Islands (Malvinas)':'FK',
            'Faroe Islands':'FO',
            'Fiji':'FJ',
            'Finland':'FI',
            'France':'FR',
            'French Guiana':'GF',
            'French Polynesia':'PF',
            'French Southern Territories':'TF',
            'Gabon':'GA',
            'Gambia':'GM',
            'Georgia':'GE',
            'Germany':'DE',
            'Ghana':'GH',
            'Gibraltar':'GI',
            'Greece':'GR',
            'Greenland':'GL',
            'Grenada':'GD',
            'Guadeloupe':'GP',
            'Guam':'GU',
            'Guatemala':'GT',
            'Guernsey':'GG',
            'Guinea':'GN',
            'Guinea-Bissau':'GW',
            'Guyana':'GY',
            'Haiti':'HT',
            'Heard Island & Mcdonald Islands':'HM',
            'Holy See (Vatican City State)':'VA',
            'Honduras':'HN',
            'Hong Kong':'HK',
            'Hungary':'HU',
            'Iceland':'IS',
            'India':'IN',
            'Indonesia':'ID',
            'Iran: Islamic Republic Of':'IR',
            'Iraq':'IQ',
            'Ireland':'IE',
            'Isle Of Man':'IM',
            'Israel':'IL',
            'Italy':'IT',
            'Jamaica':'JM',
            'Japan':'JP',
            'Jersey':'JE',
            'Jordan':'JO',
            'Kazakhstan':'KZ',
            'Kenya':'KE',
            'Kiribati':'KI',
            'Korea':'KR',
            'Kuwait':'KW',
            'Kyrgyzstan':'KG',
            'Lao People\'s Democratic Republic':'LA',
            'Latvia':'LV',
            'Lebanon':'LB',
            'Lesotho':'LS',
            'Liberia':'LR',
            'Libyan Arab Jamahiriya':'LY',
            'Liechtenstein':'LI',
            'Lithuania':'LT',
            'Luxembourg':'LU',
            'Macao':'MO',
            'Macedonia':'MK',
            'Madagascar':'MG',
            'Malawi':'MW',
            'Malaysia':'MY',
            'Maldives':'MV',
            'Mali':'ML',
            'Malta':'MT',
            'Marshall Islands':'MH',
            'Martinique':'MQ',
            'Mauritania':'MR',
            'Mauritius':'MU',
            'Mayotte':'YT',
            'Mexico':'MX',
            'Micronesia: Federated States Of':'FM',
            'Moldova':'MD',
            'Monaco':'MC',
            'Mongolia':'MN',
            'Montenegro':'ME',
            'Montserrat':'MS',
            'Morocco':'MA',
            'Mozambique':'MZ',
            'Myanmar':'MM',
            'Namibia':'NA',
            'Nauru':'NR',
            'Nepal':'NP',
            'Netherlands':'NL',
            'Netherlands Antilles':'AN',
            'New Caledonia':'NC',
            'New Zealand':'NZ',
            'Nicaragua':'NI',
            'Niger':'NE',
            'Nigeria':'NG',
            'Niue':'NU',
            'Norfolk Island':'NF',
            'Northern Mariana Islands':'MP',
            'Norway':'NO',
            'Oman':'OM',
            'Pakistan':'PK',
            'Palau':'PW',
            'Palestinian Territory: Occupied':'PS',
            'Panama':'PA',
            'Papua New Guinea':'PG',
            'Paraguay':'PY',
            'Peru':'PE',
            'Philippines':'PH',
            'Pitcairn':'PN',
            'Poland':'PL',
            'Portugal':'PT',
            'Puerto Rico':'PR',
            'Qatar':'QA',
            'Reunion':'RE',
            'Romania':'RO',
            'Russian Federation':'RU',
            'Rwanda':'RW',
            'Saint Barthelemy':'BL',
            'Saint Helena':'SH',
            'Saint Kitts And Nevis':'KN',
            'Saint Lucia':'LC',
            'Saint Martin':'MF',
            'Saint Pierre And Miquelon':'PM',
            'Saint Vincent And Grenadines':'VC',
            'Samoa':'WS',
            'San Marino':'SM',
            'Sao Tome And Principe':'ST',
            'Saudi Arabia':'SA',
            'Senegal':'SN',
            'Serbia':'RS',
            'Seychelles':'SC',
            'Sierra Leone':'SL',
            'Singapore':'SG',
            'Slovakia':'SK',
            'Slovenia':'SI',
            'Solomon Islands':'SB',
            'Somalia':'SO',
            'South Africa':'ZA',
            'South Georgia And Sandwich Isl.':'GS',
            'Spain':'ES',
            'Sri Lanka':'LK',
            'Sudan':'SD',
            'Suriname':'SR',
            'Svalbard And Jan Mayen':'SJ',
            'Swaziland':'SZ',
            'Sweden':'SE',
            'Switzerland':'CH',
            'Syrian Arab Republic':'SY',
            'Taiwan':'TW',
            'Tajikistan':'TJ',
            'Tanzania':'TZ',
            'Thailand':'TH',
            'Timor-Leste':'TL',
            'Togo':'TG',
            'Tokelau':'TK',
            'Tonga':'TO',
            'Trinidad And Tobago':'TT',
            'Tunisia':'TN',
            'Turkey':'TR',
            'Turkmenistan':'TM',
            'Turks And Caicos Islands':'TC',
            'Tuvalu':'TV',
            'Uganda':'UG',
            'Ukraine':'UA',
            'United Arab Emirates':'AE',
            'United Kingdom':'GB',
            'United States':'US',
            'United States Outlying Islands':'UM',
            'Uruguay':'UY',
            'Uzbekistan':'UZ',
            'Vanuatu':'VU',
            'Venezuela':'VE',
            'Viet Nam':'VN',
            'Virgin Islands: British':'VG',
            'Virgin Islands: U.S.':'VI',
            'Wallis And Futuna':'WF',
            'Western Sahara':'EH',
            'Yemen':'YE',
            'Zambia':'ZM',
            'Zimbabwe': 'ZW'
        }

        let result = "";
        if(type == 'ISO'){
            // @ts-ignore
            result = country[code]
        }else {
            // @ts-ignore
            result = iso[code]
        }
        return result
    };

    private confirmProcess(email: string): void {
        let parent = document.getElementsByClassName("contenedor");
        let pagina = document.getElementsByClassName("col6 pad-doble cuerpo-texto");
        pagina[0].remove();
        let container = document.createElement("span");
        container.className = "col6 pad-doble cuerpo-texto";
        parent[1].appendChild(container);
        let chart = document.createElement("div");
        chart.className ="w3-container";
        container.appendChild(chart);
        let present = document.createElement("div");
        present.className ="w3-panel w3-card";
        chart.appendChild(present);
        let filaTitulo = document.createElement("span");
        filaTitulo.className = "fila-campos"
        present.appendChild(filaTitulo);
        let header = document.createElement("h3");
        header.className ="titulo-4";
        header.innerHTML = "Congratulations, you have completed the configuration process."
        filaTitulo.appendChild(header);
        let subtitle = document.createElement("h3");
        subtitle.className = "titulo-4";
        let subtitleText = document.createElement("p")
        subtitleText.className = "texto-3"
        subtitleText.innerHTML = "You will receive a confirmation email to " +email+ "."
        filaTitulo.appendChild(subtitle);
        subtitle.appendChild(subtitleText);
        let img = document.createElement("img")
        img.className = 'icono';
        img.src = "/img/completed-checkmark-done-complete-svgrepo-com.svg"
        present.appendChild(img);
        img.style.width = "150px"
        img.style.height = "150px"
        img.style.marginLeft = "500px"
    }
}
